/* tslint:disable */
/* eslint-disable */
/**
 * suitebook
 * fvillage
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration'
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from './base'

/**
 * Cancel policy additional case
 * @export
 * @interface AdditionalCasesResponse
 */
export interface AdditionalCasesResponse {
  /**
   *
   * @type {number}
   * @memberof AdditionalCasesResponse
   */
  id?: number
  /**
   *
   * @type {number}
   * @memberof AdditionalCasesResponse
   */
  startDays?: number
  /**
   *
   * @type {number}
   * @memberof AdditionalCasesResponse
   */
  endDays?: number
  /**
   *
   * @type {number}
   * @memberof AdditionalCasesResponse
   */
  rate?: number
}
/**
 *
 * @export
 * @interface AuthTokenGoogleRequest
 */
export interface AuthTokenGoogleRequest {
  /**
   *
   * @type {string}
   * @memberof AuthTokenGoogleRequest
   */
  code?: string
  /**
   *
   * @type {string}
   * @memberof AuthTokenGoogleRequest
   */
  redirectUri?: string
}
/**
 * Auth token
 * @export
 * @interface AuthTokenResponse
 */
export interface AuthTokenResponse {
  /**
   * F Village ID(If the OIDC provider is Google: empty)
   * @type {string}
   * @memberof AuthTokenResponse
   */
  fid?: string
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  email?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  name?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  kana?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  postalCode?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  prefecture?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  address1?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  address2?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  address3?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  phone?: string | null
  /**
   *
   * @type {string}
   * @memberof AuthTokenResponse
   */
  dateOfBirth?: string | null
}
/**
 * Availability
 * @export
 * @interface AvailabilityResponse
 */
export interface AvailabilityResponse {
  /**
   * Date
   * @type {string}
   * @memberof AvailabilityResponse
   */
  date?: string
  /**
   * Percentage of availabilities
   * @type {number}
   * @memberof AvailabilityResponse
   */
  availableRate?: number | null
  /**
   * Number of available rooms
   * @type {number}
   * @memberof AvailabilityResponse
   */
  availableCount?: number | null
}
/**
 * Booking engine hotel
 * @export
 * @interface BookingEngineHotel
 */
export interface BookingEngineHotel {
  /**
   * Property id
   * @type {number}
   * @memberof BookingEngineHotel
   */
  id?: number
  /**
   * Property slug
   * @type {string}
   * @memberof BookingEngineHotel
   */
  slug?: string
  /**
   * Is hotel or not
   * @type {boolean}
   * @memberof BookingEngineHotel
   */
  isHotel?: boolean
  /**
   * Is spa or not
   * @type {boolean}
   * @memberof BookingEngineHotel
   */
  isSpa?: boolean
  /**
   * Is activity or not
   * @type {boolean}
   * @memberof BookingEngineHotel
   */
  isActivity?: boolean
  /**
   * Building official url
   * @type {string}
   * @memberof BookingEngineHotel
   */
  officialUrl?: string | null
  /**
   * GMO Payment Shop ID
   * @type {string}
   * @memberof BookingEngineHotel
   */
  gmoShopId?: string | null
  /**
   *
   * @type {Array<BookingEngineHotelPublication>}
   * @memberof BookingEngineHotel
   */
  publications?: Array<BookingEngineHotelPublication>
  /**
   * Publication images
   * @type {Array<HotelPublicationImage>}
   * @memberof BookingEngineHotel
   */
  images?: Array<HotelPublicationImage>
}
/**
 * Publications of Booking engine
 * @export
 * @interface BookingEngineHotelPublication
 */
export interface BookingEngineHotelPublication {
  /**
   * id
   * @type {number}
   * @memberof BookingEngineHotelPublication
   */
  id?: number
  /**
   * locale(`ISO639`)
   * @type {string}
   * @memberof BookingEngineHotelPublication
   */
  locale?: string
  /**
   * Property name
   * @type {string}
   * @memberof BookingEngineHotelPublication
   */
  name?: string
  /**
   * Description
   * @type {string}
   * @memberof BookingEngineHotelPublication
   */
  description?: string
  /**
   * Detail description
   * @type {string}
   * @memberof BookingEngineHotelPublication
   */
  descriptionDetail?: string
  /**
   * Note
   * @type {string}
   * @memberof BookingEngineHotelPublication
   */
  notice?: string
  /**
   * Contact
   * @type {string}
   * @memberof BookingEngineHotelPublication
   */
  contact?: string
}
/**
 *
 * @export
 * @interface BookingEngineNews
 */
export interface BookingEngineNews {
  /**
   * Content in Japanese
   * @type {string}
   * @memberof BookingEngineNews
   */
  contentJa?: string
  /**
   * Content in English
   * @type {string}
   * @memberof BookingEngineNews
   */
  contentEn?: string
}
/**
 * Notification
 * @export
 * @interface BookingEngineNotification
 */
export interface BookingEngineNotification {
  /**
   * ID
   * @type {number}
   * @memberof BookingEngineNotification
   */
  id?: number
  /**
   * Notification type   * `0` - Info   * `1` - Warning   * `2` - Error
   * @type {number}
   * @memberof BookingEngineNotification
   */
  noticeType?: BookingEngineNotificationNoticeTypeEnum
  /**
   * Description in japanese
   * @type {string}
   * @memberof BookingEngineNotification
   */
  contentJa?: string
  /**
   * Description in english
   * @type {string}
   * @memberof BookingEngineNotification
   */
  contentEn?: string
}

export const BookingEngineNotificationNoticeTypeEnum = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const

export type BookingEngineNotificationNoticeTypeEnum =
  (typeof BookingEngineNotificationNoticeTypeEnum)[keyof typeof BookingEngineNotificationNoticeTypeEnum]

/**
 * Room type publication
 * @export
 * @interface BookingEngineRoomPublication
 */
export interface BookingEngineRoomPublication {
  /**
   * Room type publication id
   * @type {number}
   * @memberof BookingEngineRoomPublication
   */
  id?: number
  /**
   * Locale(`ISO639`)
   * @type {string}
   * @memberof BookingEngineRoomPublication
   */
  locale?: string
  /**
   * Room category
   * @type {string}
   * @memberof BookingEngineRoomPublication
   */
  name?: string
  /**
   * Description of room category
   * @type {string}
   * @memberof BookingEngineRoomPublication
   */
  description?: string
  /**
   * Room category detail (HTML)
   * @type {string}
   * @memberof BookingEngineRoomPublication
   */
  descriptionDetail?: string
}
/**
 *
 * @export
 * @interface BotVerificationConfigurationResponse
 */
export interface BotVerificationConfigurationResponse {
  /**
   *
   * @type {boolean}
   * @memberof BotVerificationConfigurationResponse
   */
  enabled: boolean
  /**
   *
   * @type {string}
   * @memberof BotVerificationConfigurationResponse
   */
  siteKey: string
  /**
   *
   * @type {string}
   * @memberof BotVerificationConfigurationResponse
   */
  action: string
  /**
   *
   * @type {string}
   * @memberof BotVerificationConfigurationResponse
   */
  context: string
}
/**
 *
 * @export
 * @interface CancelConfirmation
 */
export interface CancelConfirmation {
  /**
   *
   * @type {boolean}
   * @memberof CancelConfirmation
   */
  canCancel?: boolean
  /**
   *
   * @type {number}
   * @memberof CancelConfirmation
   */
  cancellationFee?: number
}
/**
 * Cancel policy
 * @export
 * @interface CancelPolicyResponse
 */
export interface CancelPolicyResponse {
  /**
   *
   * @type {number}
   * @memberof CancelPolicyResponse
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof CancelPolicyResponse
   */
  name?: string
  /**
   *
   * @type {boolean}
   * @memberof CancelPolicyResponse
   */
  nonRefundable?: boolean
  /**
   *
   * @type {boolean}
   * @memberof CancelPolicyResponse
   */
  needsDeposit?: boolean
  /**
   *
   * @type {number}
   * @memberof CancelPolicyResponse
   */
  noShowRate?: number | null
  /**
   *
   * @type {number}
   * @memberof CancelPolicyResponse
   */
  cancellationTodayRate?: number | null
  /**
   *
   * @type {Array<AdditionalCasesResponse>}
   * @memberof CancelPolicyResponse
   */
  additionalCases?: Array<AdditionalCasesResponse>
}
/**
 *
 * @export
 * @interface CreateReservationRequest
 */
export interface CreateReservationRequest {
  /**
   * Transaction ID
   * @type {number}
   * @memberof CreateReservationRequest
   */
  transactionId?: number
}
/**
 *
 * @export
 * @interface CreateTransaction201Response
 */
export interface CreateTransaction201Response {
  /**
   * Transaction ID
   * @type {number}
   * @memberof CreateTransaction201Response
   */
  id?: number
}
/**
 *
 * @export
 * @interface CreateTransactionRequest
 */
export interface CreateTransactionRequest {
  /**
   *
   * @type {CreateTransactionRequestInput}
   * @memberof CreateTransactionRequest
   */
  input?: CreateTransactionRequestInput
}
/**
 *
 * @export
 * @interface CreateTransactionRequestInput
 */
export interface CreateTransactionRequestInput {
  /**
   * Hotel slug
   * @type {string}
   * @memberof CreateTransactionRequestInput
   */
  bookingEngineHotel?: string
  /**
   * Room category slug
   * @type {string}
   * @memberof CreateTransactionRequestInput
   */
  bookingEngineRoom?: string
  /**
   * Plan slug
   * @type {string}
   * @memberof CreateTransactionRequestInput
   */
  bookingEnginePlan?: string
  /**
   * Number of adults
   * @type {number}
   * @memberof CreateTransactionRequestInput
   */
  numberOfAdults?: number
  /**
   * Number of children
   * @type {number}
   * @memberof CreateTransactionRequestInput
   */
  numberOfChildren?: number
  /**
   * Number of infants
   * @type {number}
   * @memberof CreateTransactionRequestInput
   */
  numberOfInfants?: number
  /**
   * Check-in date(`yyyy-MM-dd`)
   * @type {string}
   * @memberof CreateTransactionRequestInput
   */
  checkInDate?: string
  /**
   * Check-out date(`yyyy-MM-dd`)
   * @type {string}
   * @memberof CreateTransactionRequestInput
   */
  checkOutDate?: string
  /**
   * Number of rooms
   * @type {number}
   * @memberof CreateTransactionRequestInput
   */
  roomCount?: number
  /**
   * Option items
   * @type {Array<OptionItem>}
   * @memberof CreateTransactionRequestInput
   */
  options?: Array<OptionItem>
  /**
   * Invoice billing key from the plan\'s invoice URL (`?invoice_key=`). A key that does not open the plan is rejected with `invoice_access_key` in invalidParams.
   * @type {string}
   * @memberof CreateTransactionRequestInput
   */
  invoiceAccessKey?: string
}
/**
 *
 * @export
 * @interface GetHotelDetail200Response
 */
export interface GetHotelDetail200Response {
  /**
   * Access information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  access?: Array<HotelDetail>
  /**
   * Activity information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  activities?: Array<HotelDetail>
  /**
   * Meal information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  meals?: Array<HotelDetail>
  /**
   * Pickup information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  pickups?: Array<HotelDetail>
  /**
   * Facility and space information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  spaces?: Array<HotelDetail>
  /**
   * Guideline information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  guidelines?: Array<HotelDetail>
  /**
   * FAQ
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  faqs?: Array<HotelDetail>
  /**
   * Information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  information?: Array<HotelDetail>
  /**
   * Amenity information
   * @type {Array<HotelDetail>}
   * @memberof GetHotelDetail200Response
   */
  amenities?: Array<HotelDetail>
}
/**
 * Hotel detail information
 * @export
 * @interface HotelDetail
 */
export interface HotelDetail {
  /**
   * Publication ID
   * @type {number}
   * @memberof HotelDetail
   */
  id?: number
  /**
   * Publication information
   * @type {Array<HotelDetailPublication>}
   * @memberof HotelDetail
   */
  publications?: Array<HotelDetailPublication>
  /**
   * Publication images
   * @type {Array<HotelPublicationImage>}
   * @memberof HotelDetail
   */
  images?: Array<HotelPublicationImage>
}
/**
 * Hotel detail publication information
 * @export
 * @interface HotelDetailPublication
 */
export interface HotelDetailPublication {
  /**
   * Publication ID
   * @type {number}
   * @memberof HotelDetailPublication
   */
  id?: number
  /**
   * Language code (`ISO639`)
   * @type {string}
   * @memberof HotelDetailPublication
   */
  locale?: string
  /**
   * Publication title
   * @type {string}
   * @memberof HotelDetailPublication
   */
  name?: string
  /**
   * Listing information identifier
   * @type {string}
   * @memberof HotelDetailPublication
   */
  shortName?: string
  /**
   * Publication content
   * @type {string}
   * @memberof HotelDetailPublication
   */
  description?: string
  /**
   * Publication content (HTML data)
   * @type {string}
   * @memberof HotelDetailPublication
   */
  descriptionDetail?: string
  /**
   * Icon
   * @type {string}
   * @memberof HotelDetailPublication
   */
  icon?: string
  /**
   * Sort order
   * @type {number}
   * @memberof HotelDetailPublication
   */
  sort?: number
  /**
   * URL
   * @type {string}
   * @memberof HotelDetailPublication
   */
  url?: string
}
/**
 * Publication image
 * @export
 * @interface HotelPublicationImage
 */
export interface HotelPublicationImage {
  /**
   * Publication image ID
   * @type {number}
   * @memberof HotelPublicationImage
   */
  id?: number
  /**
   * URL
   * @type {string}
   * @memberof HotelPublicationImage
   */
  url?: string
  /**
   * Title
   * @type {string}
   * @memberof HotelPublicationImage
   */
  title?: string
  /**
   * Whether it is a hero image for PC
   * @type {boolean}
   * @memberof HotelPublicationImage
   */
  isHeroPc?: boolean
  /**
   * Whether it is a hero image for SP
   * @type {boolean}
   * @memberof HotelPublicationImage
   */
  isHeroSp?: boolean
}
/**
 * Room Availability
 * @export
 * @interface HotelRoomAvailabilityResponse
 */
export interface HotelRoomAvailabilityResponse {
  /**
   *
   * @type {number}
   * @memberof HotelRoomAvailabilityResponse
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof HotelRoomAvailabilityResponse
   */
  slug?: string
  /**
   *
   * @type {Array<BookingEngineRoomPublication>}
   * @memberof HotelRoomAvailabilityResponse
   */
  publications?: Array<BookingEngineRoomPublication>
  /**
   *
   * @type {Array<ImageResponse>}
   * @memberof HotelRoomAvailabilityResponse
   */
  images?: Array<ImageResponse>
  /**
   *
   * @type {Array<RoomDailyAvailability>}
   * @memberof HotelRoomAvailabilityResponse
   */
  availabilities?: Array<RoomDailyAvailability>
}
/**
 *
 * @export
 * @interface HotelRoomListResponse
 */
export interface HotelRoomListResponse {
  /**
   *
   * @type {number}
   * @memberof HotelRoomListResponse
   */
  count?: number
  /**
   *
   * @type {string}
   * @memberof HotelRoomListResponse
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof HotelRoomListResponse
   */
  previous?: string | null
  /**
   *
   * @type {Array<HotelRoomResponse>}
   * @memberof HotelRoomListResponse
   */
  results?: Array<HotelRoomResponse>
}
/**
 * Hotel Availability
 * @export
 * @interface HotelRoomResponse
 */
export interface HotelRoomResponse {
  /**
   * Hotel id
   * @type {number}
   * @memberof HotelRoomResponse
   */
  id?: number
  /**
   * Hotel slug
   * @type {string}
   * @memberof HotelRoomResponse
   */
  slug?: string
  /**
   * rooms
   * @type {Array<RoomResponse>}
   * @memberof HotelRoomResponse
   */
  rooms?: Array<RoomResponse>
  /**
   * publications
   * @type {Array<PublicationResponse>}
   * @memberof HotelRoomResponse
   */
  publications?: Array<PublicationResponse>
  /**
   * Publication images
   * @type {Array<HotelPublicationImage>}
   * @memberof HotelRoomResponse
   */
  images?: Array<HotelPublicationImage>
}
/**
 * Image
 * @export
 * @interface ImageResponse
 */
export interface ImageResponse {
  /**
   *
   * @type {number}
   * @memberof ImageResponse
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ImageResponse
   */
  url: string
  /**
   *
   * @type {string}
   * @memberof ImageResponse
   */
  title: string
  /**
   * Image category
   * @type {string}
   * @memberof ImageResponse
   */
  category?: ImageResponseCategoryEnum
}

export const ImageResponseCategoryEnum = {
  Others: 'OTHERS',
  Room: 'ROOM',
  Equipment: 'EQUIPMENT',
  Meal: 'MEAL',
  Service: 'SERVICE',
  Facility: 'FACILITY',
  Layout: 'LAYOUT',
} as const

export type ImageResponseCategoryEnum =
  (typeof ImageResponseCategoryEnum)[keyof typeof ImageResponseCategoryEnum]

/**
 * エラーが発生したパラメータの情報を返すために利用します
 * @export
 * @interface InvalidParameterResponse
 */
export interface InvalidParameterResponse {
  /**
   * パラメータ名
   * @type {string}
   * @memberof InvalidParameterResponse
   */
  name?: string
  /**
   * エラーが発生した理由
   * @type {string}
   * @memberof InvalidParameterResponse
   */
  reason?: string
}
/**
 *
 * @export
 * @interface IssueReceiptRequest
 */
export interface IssueReceiptRequest {
  /**
   *
   * @type {string}
   * @memberof IssueReceiptRequest
   */
  addressee: string
}
/**
 *
 * @export
 * @interface IssueReceiptResponse
 */
export interface IssueReceiptResponse {
  /**
   *
   * @type {Array<number>}
   * @memberof IssueReceiptResponse
   */
  receipts: Array<number>
}
/**
 *
 * @export
 * @interface LogoutRequest
 */
export interface LogoutRequest {
  /**
   *
   * @type {string}
   * @memberof LogoutRequest
   */
  token?: string
}
/**
 * エラーが発生した際に利用されるデータ構造です。
 * @export
 * @interface ModelErrorResponse
 */
export interface ModelErrorResponse {
  /**
   * RFC7807を参照。エラーのタイプを表すURI参照[RFC3986]です
   * @type {string}
   * @memberof ModelErrorResponse
   */
  type?: string
  /**
   * RFC7807を参照。エラーのタイトルです
   * @type {string}
   * @memberof ModelErrorResponse
   */
  title?: string
  /**
   * エラーの詳細な内容です。この内容をシステムで解析して利用しないでください。この文章は予告なしに変更される場合があります
   * @type {string}
   * @memberof ModelErrorResponse
   */
  detail?: string
  /**
   * 3桁のStatusコードです
   * @type {number}
   * @memberof ModelErrorResponse
   */
  status?: number
  /**
   * 本APIで独自に定義している4桁のエラーコード   - `1001` - 認証エラー (HTTPステータスコード: 401)   - `1002` - 許可されていない操作 (HTTPステータスコード: 403)   - `1003` - 不正なリクエスト (HTTPステータスコード: 400)   - `1004` - 存在しないオブジェクト (HTTPステータスコード: 404)   - `1005` - サーバーエラー (HTTPステータスコード: 500)   - `1006` - 許可されていないメソッド (HTTPステータスコード: 405)   - `2001` - [Booking Engine] 販売されてない部屋のため予約不可 (HTTPステータスコード: 400)   - `2002` - [Booking Engine] 販売されてないプランのため予約不可 (HTTPステータスコード: 400)   - `2003` - [Booking Engine] 部屋の在庫がないため予約不可 (HTTPステータスコード: 400)   - `2004` - [Booking Engine] クーポンコードが有効でないため予約不可 (HTTPステータスコード: 400)   - `2005` - [Booking Engine] 販売されてないオプションのため予約不可 (HTTPステータスコード: 400)   - `2006` - [Booking Engine] キャンセル可能期間を過ぎているためキャンセル不可 (HTTPステータスコード: 400)   - `2007` - [Booking Engine] 販売されてないチケットのため予約不可 (HTTPステータスコード: 400)   - `2008` - [Booking Engine] チケットが売り切れのため予約不可 (HTTPステータスコード: 400)   - `2009` - [Booking Engine] 北広島市以外で旅先納税クーポンコードが適用されたため予約不可 (HTTPステータスコード: 400)   - `2018` - [Booking Engine] TL-Lincolnメンテナンス中のため予約不可 (HTTPステータスコード: 400)   - `2019` - [Booking Engine] TL-Lincolnの予約可能期間（13か月）を超える宿泊日のため予約不可 (HTTPステータスコード: 400)   - `2101` - [GMOペイメント決済] 店舗まで問い合わせが必要なエラー (HTTPステータスコード: 400)   - `2102` - [GMOペイメント決済] クレジットカード起因のオーソリエラー (HTTPステータスコード: 400)   - `2103` - [GMOペイメント決済] 入力情報エラー (HTTPステータスコード: 400)   - `2104` - [GMOペイメント決済] リトライ必要なエラー (HTTPステータスコード: 400)   - `2105` - [GMOペイメント決済] レスポンスタイムアウト（リトライ不要） (HTTPステータスコード: 400)
   * @type {number}
   * @memberof ModelErrorResponse
   */
  errorCode?: ModelErrorResponseErrorCodeEnum
  /**
   * パラメータに問題があった場合には、ここに詳細情報が記載されます。
   * @type {Array<InvalidParameterResponse>}
   * @memberof ModelErrorResponse
   */
  invalidParams?: Array<InvalidParameterResponse>
}

export const ModelErrorResponseErrorCodeEnum = {
  AuthError: 1001,
  OperationNotAllowedError: 1002,
  BadRequestError: 1003,
  NotFoundError: 1004,
  InternalServerError: 1005,
  MethodNotAllowedError: 1006,
  RoomNotForSaleError: 2001,
  PlanNotForSaleError: 2002,
  NoStockError: 2003,
  DiscountCodeInvalidError: 2004,
  OptionItemNotForSaleError: 2005,
  CannotCancelError: 2006,
  TicketNotForSaleError: 2007,
  SoldOutError: 2008,
  KitahiroshimaDiscountCodeInvalidError: 2009,
  PlatformUnderMaintenanceError: 2018,
  BookingWindowExceededError: 2019,
  NeedToContactTheStoreError: 2101,
  AuthorizationErrorCausedByCreditCardError: 2102,
  RetryAfterCheckingInputError: 2103,
  RequiringRetryError: 2104,
  ResponseTimeoutError: 2105,
} as const

export type ModelErrorResponseErrorCodeEnum =
  (typeof ModelErrorResponseErrorCodeEnum)[keyof typeof ModelErrorResponseErrorCodeEnum]

/**
 * Answer to an option input field
 * @export
 * @interface OptionAnswer
 */
export interface OptionAnswer {
  /**
   * Input field id
   * @type {number}
   * @memberof OptionAnswer
   */
  inputField: number
  /**
   * Answer (the choice key for a select field, ASCII digits for a number field)
   * @type {string}
   * @memberof OptionAnswer
   */
  value?: string
}
/**
 * Choice of a select input field
 * @export
 * @interface OptionInputFieldChoiceResponse
 */
export interface OptionInputFieldChoiceResponse {
  /**
   * Choice key (sent as the answer value)
   * @type {string}
   * @memberof OptionInputFieldChoiceResponse
   */
  key: string
  /**
   *
   * @type {Array<OptionLocalizedLabelResponse>}
   * @memberof OptionInputFieldChoiceResponse
   */
  labels: Array<OptionLocalizedLabelResponse>
}
/**
 * Guest input field of an option
 * @export
 * @interface OptionInputFieldResponse
 */
export interface OptionInputFieldResponse {
  /**
   * Input field id
   * @type {number}
   * @memberof OptionInputFieldResponse
   */
  id: number
  /**
   * Input type   * `1` - Text   * `2` - Select   * `3` - Number (non-negative integer)
   * @type {number}
   * @memberof OptionInputFieldResponse
   */
  fieldType: OptionInputFieldResponseFieldTypeEnum
  /**
   * Whether the field is required
   * @type {boolean}
   * @memberof OptionInputFieldResponse
   */
  isRequired: boolean
  /**
   * Field name (ja is always present)
   * @type {Array<OptionLocalizedLabelResponse>}
   * @memberof OptionInputFieldResponse
   */
  labels: Array<OptionLocalizedLabelResponse>
  /**
   * Choices (select fields only)
   * @type {Array<OptionInputFieldChoiceResponse>}
   * @memberof OptionInputFieldResponse
   */
  choices: Array<OptionInputFieldChoiceResponse>
}

export const OptionInputFieldResponseFieldTypeEnum = {
  Text: 1,
  Select: 2,
  Number: 3,
} as const

export type OptionInputFieldResponseFieldTypeEnum =
  (typeof OptionInputFieldResponseFieldTypeEnum)[keyof typeof OptionInputFieldResponseFieldTypeEnum]

/**
 * Option
 * @export
 * @interface OptionItem
 */
export interface OptionItem {
  /**
   * Option item id
   * @type {number}
   * @memberof OptionItem
   */
  option?: number
  /**
   * Purchase date
   * @type {string}
   * @memberof OptionItem
   */
  date?: string | null
  /**
   * Number of purchases
   * @type {number}
   * @memberof OptionItem
   */
  count?: number
  /**
   * Answers to the option\'s input fields, one set per option regardless of count or nights. A blank required field, an unknown choice, a number field that is not a non-negative integer, or a field of another option is rejected with 400.
   * @type {Array<OptionAnswer>}
   * @memberof OptionItem
   */
  answers?: Array<OptionAnswer>
}
/**
 * Label per locale
 * @export
 * @interface OptionLocalizedLabelResponse
 */
export interface OptionLocalizedLabelResponse {
  /**
   * Locale (ja / en / zh / zh-CN / zh-Hant-TW / ko)
   * @type {string}
   * @memberof OptionLocalizedLabelResponse
   */
  locale: string
  /**
   *
   * @type {string}
   * @memberof OptionLocalizedLabelResponse
   */
  label: string
}
/**
 * Option
 * @export
 * @interface OptionResponse
 */
export interface OptionResponse {
  /**
   * Id
   * @type {number}
   * @memberof OptionResponse
   */
  id?: number
  /**
   * Publications
   * @type {Array<PublicationResponse>}
   * @memberof OptionResponse
   */
  publications?: Array<PublicationResponse>
  /**
   *
   * @type {Array<ImageResponse>}
   * @memberof OptionResponse
   */
  images?: Array<ImageResponse>
  /**
   * Possible to cancel or not
   * @type {boolean}
   * @memberof OptionResponse
   */
  canCancel?: boolean
  /**
   *
   * @type {Array<StockResponse>}
   * @memberof OptionResponse
   */
  stocks?: Array<StockResponse>
  /**
   *
   * @type {number}
   * @memberof OptionResponse
   */
  unitSellingPrice?: number
  /**
   *
   * @type {string}
   * @memberof OptionResponse
   */
  currencyCode?: OptionResponseCurrencyCodeEnum
  /**
   * Notification type   * `10` - LateCheckOut30Min   * `20` - RoomAssignment   * `30` - GameTicket
   * @type {number}
   * @memberof OptionResponse
   */
  usage?: OptionResponseUsageEnum
  /**
   * Guest input fields in display order
   * @type {Array<OptionInputFieldResponse>}
   * @memberof OptionResponse
   */
  inputFields?: Array<OptionInputFieldResponse>
}

export const OptionResponseCurrencyCodeEnum = {
  Jpy: 'JPY',
} as const

export type OptionResponseCurrencyCodeEnum =
  (typeof OptionResponseCurrencyCodeEnum)[keyof typeof OptionResponseCurrencyCodeEnum]
export const OptionResponseUsageEnum = {
  LateCheckOut30Min: 10,
  RoomAssignment: 20,
  GameTicket: 30,
} as const

export type OptionResponseUsageEnum =
  (typeof OptionResponseUsageEnum)[keyof typeof OptionResponseUsageEnum]

/**
 * Option
 * @export
 * @interface OverViewOption
 */
export interface OverViewOption {
  /**
   * Purchase target date
   * @type {string}
   * @memberof OverViewOption
   */
  date?: string | null
  /**
   * Number of purchases
   * @type {number}
   * @memberof OverViewOption
   */
  count?: number
  /**
   * unitSellingPrice * count
   * @type {number}
   * @memberof OverViewOption
   */
  salesPrice?: number
  /**
   * Price
   * @type {number}
   * @memberof OverViewOption
   */
  unitSellingPrice?: number
  /**
   *
   * @type {OverViewOptionPublication}
   * @memberof OverViewOption
   */
  option?: OverViewOptionPublication
}
/**
 * Overview of option
 * @export
 * @interface OverViewOptionPublication
 */
export interface OverViewOptionPublication {
  /**
   * Option id
   * @type {number}
   * @memberof OverViewOptionPublication
   */
  id?: number
  /**
   * Option publication
   * @type {Array<PublicationResponse>}
   * @memberof OverViewOptionPublication
   */
  publications?: Array<PublicationResponse>
}
/**
 * Overview of plan
 * @export
 * @interface OverViewPlan
 */
export interface OverViewPlan {
  /**
   * Plan id
   * @type {number}
   * @memberof OverViewPlan
   */
  id?: number
  /**
   * Plan slug
   * @type {string}
   * @memberof OverViewPlan
   */
  slug?: string
  /**
   * Meal
   * @type {number}
   * @memberof OverViewPlan
   */
  meal?: number | null
  /**
   * Check in time start（`HH:mm`）
   * @type {string}
   * @memberof OverViewPlan
   */
  checkInTimeStart?: string | null
  /**
   * Check in time start（`HH:mm`）
   * @type {string}
   * @memberof OverViewPlan
   */
  checkInTimeEnd?: string | null
  /**
   * Check out time end（`HH:mm`）
   * @type {string}
   * @memberof OverViewPlan
   */
  checkOutTimeEnd?: string | null
  /**
   * Check-in available time start note
   * @type {string}
   * @memberof OverViewPlan
   */
  checkInTimeStartNote?: string | null
  /**
   * Check-in available time end note
   * @type {string}
   * @memberof OverViewPlan
   */
  checkInTimeEndNote?: string | null
  /**
   * Check-out time end note
   * @type {string}
   * @memberof OverViewPlan
   */
  checkOutTimeEndNote?: string | null
  /**
   *
   * @type {Array<PublicationResponse>}
   * @memberof OverViewPlan
   */
  publications?: Array<PublicationResponse>
}
/**
 * Overview of room category
 * @export
 * @interface OverViewRoom
 */
export interface OverViewRoom {
  /**
   * Room category id
   * @type {number}
   * @memberof OverViewRoom
   */
  id?: number
  /**
   * Room category slug
   * @type {string}
   * @memberof OverViewRoom
   */
  slug?: string
  /**
   *
   * @type {Array<BookingEngineRoomPublication>}
   * @memberof OverViewRoom
   */
  publications?: Array<BookingEngineRoomPublication>
}
/**
 *
 * @export
 * @interface PatchDiscountRequest
 */
export interface PatchDiscountRequest {
  /**
   *
   * @type {string}
   * @memberof PatchDiscountRequest
   */
  discountCode?: string
}
/**
 * A room paired with this plan\'s price for that room
 * @export
 * @interface PlanAvailableRoom
 */
export interface PlanAvailableRoom {
  /**
   *
   * @type {RoomResponse}
   * @memberof PlanAvailableRoom
   */
  room: RoomResponse
  /**
   *
   * @type {PlanResponse}
   * @memberof PlanAvailableRoom
   */
  plan: PlanResponse
}
/**
 * plan publication
 * @export
 * @interface PlanPublication
 */
export interface PlanPublication {
  /**
   * plan publication id
   * @type {number}
   * @memberof PlanPublication
   */
  id?: number
  /**
   * Locale(`ISO639`)
   * @type {string}
   * @memberof PlanPublication
   */
  locale?: string
  /**
   * plan name
   * @type {string}
   * @memberof PlanPublication
   */
  name?: string
  /**
   * plan description
   * @type {string}
   * @memberof PlanPublication
   */
  description?: string
  /**
   * plan description (HTML)
   * @type {string}
   * @memberof PlanPublication
   */
  descriptionDetail?: string
}
/**
 * Plan
 * @export
 * @interface PlanResponse
 */
export interface PlanResponse {
  /**
   * Recommendation priority; set values sort ascending before plans without a priority.
   * @type {number}
   * @memberof PlanResponse
   */
  displayOrder?: number | null
  /**
   *
   * @type {number}
   * @memberof PlanResponse
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof PlanResponse
   */
  slug?: string
  /**
   *
   * @type {string}
   * @memberof PlanResponse
   */
  payment: string
  /**
   *
   * @type {number}
   * @memberof PlanResponse
   */
  meal: number | null
  /**
   *
   * @type {number}
   * @memberof PlanResponse
   */
  limitation: number | null
  /**
   *
   * @type {boolean}
   * @memberof PlanResponse
   */
  includesServiceCharge: boolean
  /**
   *
   * @type {number}
   * @memberof PlanResponse
   */
  serviceChargeRate: number
  /**
   * Check-in available time(`HH:mm`)
   * @type {string}
   * @memberof PlanResponse
   */
  checkInTimeStart?: string | null
  /**
   * Check-in available time(`HH:mm`)
   * @type {string}
   * @memberof PlanResponse
   */
  checkInTimeEnd?: string | null
  /**
   * Check-out available time(`HH:mm`)
   * @type {string}
   * @memberof PlanResponse
   */
  checkOutTimeEnd?: string | null
  /**
   * Check-in available time start note
   * @type {string}
   * @memberof PlanResponse
   */
  checkInTimeStartNote?: string | null
  /**
   * Check-in available time end note
   * @type {string}
   * @memberof PlanResponse
   */
  checkInTimeEndNote?: string | null
  /**
   * Check-out time note
   * @type {string}
   * @memberof PlanResponse
   */
  checkOutTimeEndNote?: string | null
  /**
   *
   * @type {Array<ImageResponse>}
   * @memberof PlanResponse
   */
  images?: Array<ImageResponse>
  /**
   *
   * @type {Array<PlanPublication>}
   * @memberof PlanResponse
   */
  publications?: Array<PlanPublication>
  /**
   *
   * @type {CancelPolicyResponse}
   * @memberof PlanResponse
   */
  cancelPolicy?: CancelPolicyResponse
  /**
   * Price
   * @type {number}
   * @memberof PlanResponse
   */
  price?: number
  /**
   * Can reserve or not
   * @type {boolean}
   * @memberof PlanResponse
   */
  canReserve?: boolean
  /**
   * Can buy option items or not
   * @type {boolean}
   * @memberof PlanResponse
   */
  withOptions?: boolean
  /**
   * Whether accommodation tax is collected on site
   * @type {boolean}
   * @memberof PlanResponse
   */
  collectAccommodationTaxOnSite: boolean
  /**
   * Whether bath tax is collected on site
   * @type {boolean}
   * @memberof PlanResponse
   */
  collectBathTaxOnSite: boolean
  /**
   * Whether this plan is a secret plan
   * @type {boolean}
   * @memberof PlanResponse
   */
  isSecret?: boolean
}
/**
 * A plan with the rooms it is bookable on
 * @export
 * @interface PlanWithRoomsResponse
 */
export interface PlanWithRoomsResponse {
  /**
   *
   * @type {PlanResponse}
   * @memberof PlanWithRoomsResponse
   */
  plan: PlanResponse
  /**
   * Rooms this plan is bookable on, with the per-room price for THIS plan. Search is always evaluated (missing params fall back to defaults), so each entry\'s plan is always priced.
   * @type {Array<PlanAvailableRoom>}
   * @memberof PlanWithRoomsResponse
   */
  availableRooms: Array<PlanAvailableRoom>
}
/**
 * Price
 * @export
 * @interface PriceResponse
 */
export interface PriceResponse {
  /**
   * Room price
   * @type {number}
   * @memberof PriceResponse
   */
  roomPrice?: number
  /**
   * Optional price
   * @type {number}
   * @memberof PriceResponse
   */
  optionPrice?: number | null
  /**
   * オプション料金の詳細
   * @type {Array<PriceResponseOptionsInner>}
   * @memberof PriceResponse
   */
  options?: Array<PriceResponseOptionsInner>
  /**
   * Discount
   * @type {number}
   * @memberof PriceResponse
   */
  discountPrice?: number | null
  /**
   * Applied coupon id
   * @type {number}
   * @memberof PriceResponse
   */
  discountId?: number | null
  /**
   * Applied coupon name
   * @type {string}
   * @memberof PriceResponse
   */
  discountName?: string | null
  /**
   * Taxes
   * @type {Array<Tax>}
   * @memberof PriceResponse
   */
  taxes?: Array<Tax>
  /**
   * Total tax amount
   * @type {number}
   * @memberof PriceResponse
   */
  totalTaxAmount?: number
  /**
   * Total price(exclude tax)
   * @type {number}
   * @memberof PriceResponse
   */
  totalPriceExcludingTax?: number
  /**
   * Total price(include tax)
   * @type {number}
   * @memberof PriceResponse
   */
  totalPrice?: number
  /**
   * Discount code
   * @type {string}
   * @memberof PriceResponse
   */
  discountCode?: string | null
  /**
   * Cancellation fee
   * @type {number}
   * @memberof PriceResponse
   */
  cancellationFee?: number | null
  /**
   * Whether accommodation tax is collected on site
   * @type {boolean}
   * @memberof PriceResponse
   */
  collectAccommodationTaxOnSite?: boolean
  /**
   * Whether bath tax is collected on site
   * @type {boolean}
   * @memberof PriceResponse
   */
  collectBathTaxOnSite?: boolean
  /**
   * Payment method of the booking. ADVANCE = online card payment in advance, ONSITE = paid at the property on site, INVOICE = billed by invoice without collecting a card (an ADVANCE plan booked with its invoice key), LATER = paid after the stay.
   * @type {string}
   * @memberof PriceResponse
   */
  paymentType?: PriceResponsePaymentTypeEnum
}

export const PriceResponsePaymentTypeEnum = {
  Advance: 'ADVANCE',
  Onsite: 'ONSITE',
  Invoice: 'INVOICE',
  Later: 'LATER',
} as const

export type PriceResponsePaymentTypeEnum =
  (typeof PriceResponsePaymentTypeEnum)[keyof typeof PriceResponsePaymentTypeEnum]

/**
 *
 * @export
 * @interface PriceResponseOptionsInner
 */
export interface PriceResponseOptionsInner {
  /**
   * オプションID
   * @type {number}
   * @memberof PriceResponseOptionsInner
   */
  id?: number
  /**
   * 個数
   * @type {number}
   * @memberof PriceResponseOptionsInner
   */
  unit?: number
  /**
   * 単価
   * @type {number}
   * @memberof PriceResponseOptionsInner
   */
  price?: number
  /**
   * 合計金額
   * @type {number}
   * @memberof PriceResponseOptionsInner
   */
  total?: number
}
/**
 *
 * @export
 * @interface PropertyAvailabilityListResponse
 */
export interface PropertyAvailabilityListResponse {
  /**
   *
   * @type {number}
   * @memberof PropertyAvailabilityListResponse
   */
  count?: number
  /**
   *
   * @type {string}
   * @memberof PropertyAvailabilityListResponse
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof PropertyAvailabilityListResponse
   */
  previous?: string | null
  /**
   *
   * @type {Array<PropertyAvailabilityResponse>}
   * @memberof PropertyAvailabilityListResponse
   */
  results?: Array<PropertyAvailabilityResponse>
}
/**
 * Property availability
 * @export
 * @interface PropertyAvailabilityResponse
 */
export interface PropertyAvailabilityResponse {
  /**
   * Booking id
   * @type {number}
   * @memberof PropertyAvailabilityResponse
   */
  id?: number
  /**
   * Building slug
   * @type {string}
   * @memberof PropertyAvailabilityResponse
   */
  slug?: string
  /**
   * Is inside Fvillage or not
   * @type {boolean}
   * @memberof PropertyAvailabilityResponse
   */
  insideFvillage?: boolean
  /**
   * Has details page
   * @type {boolean}
   * @memberof PropertyAvailabilityResponse
   */
  hasDetails?: boolean
  /**
   * Availabilities
   * @type {Array<AvailabilityResponse>}
   * @memberof PropertyAvailabilityResponse
   */
  availabilities?: Array<AvailabilityResponse>
  /**
   * Publications
   * @type {Array<PublicationResponse>}
   * @memberof PropertyAvailabilityResponse
   */
  publications?: Array<PublicationResponse>
  /**
   * Publication images
   * @type {Array<HotelPublicationImage>}
   * @memberof PropertyAvailabilityResponse
   */
  images?: Array<HotelPublicationImage>
}
/**
 *
 * @export
 * @interface PropertyListResponse
 */
export interface PropertyListResponse {
  /**
   *
   * @type {number}
   * @memberof PropertyListResponse
   */
  count?: number
  /**
   *
   * @type {string}
   * @memberof PropertyListResponse
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof PropertyListResponse
   */
  previous?: string | null
  /**
   *
   * @type {Array<PropertyResponse>}
   * @memberof PropertyListResponse
   */
  results?: Array<PropertyResponse>
}
/**
 * Property availability
 * @export
 * @interface PropertyResponse
 */
export interface PropertyResponse {
  /**
   * Booking id
   * @type {number}
   * @memberof PropertyResponse
   */
  id?: number
  /**
   * Building name
   * @type {string}
   * @memberof PropertyResponse
   */
  name?: string
  /**
   * Is hotel or not
   * @type {boolean}
   * @memberof PropertyResponse
   */
  isHotel?: boolean
  /**
   * Is spa or not
   * @type {boolean}
   * @memberof PropertyResponse
   */
  isSpa?: boolean
  /**
   * Is activity or not
   * @type {boolean}
   * @memberof PropertyResponse
   */
  isActivity?: boolean
  /**
   * Is inside FVillage or not
   * @type {boolean}
   * @memberof PropertyResponse
   */
  insideFvillage?: boolean
  /**
   * Has details page
   * @type {boolean}
   * @memberof PropertyResponse
   */
  hasDetails?: boolean
  /**
   * Building official url
   * @type {string}
   * @memberof PropertyResponse
   */
  officialUrl?: string | null
  /**
   * GMO Payment Shop ID
   * @type {string}
   * @memberof PropertyResponse
   */
  gmoShopId?: string | null
  /**
   * Building slug
   * @type {string}
   * @memberof PropertyResponse
   */
  slug?: string
  /**
   * Publications
   * @type {Array<PublicationResponse>}
   * @memberof PropertyResponse
   */
  publications?: Array<PublicationResponse>
  /**
   * Publication images
   * @type {Array<HotelPublicationImage>}
   * @memberof PropertyResponse
   */
  images?: Array<HotelPublicationImage>
  /**
   * URL of airline ticket reservation
   * @type {string}
   * @memberof PropertyResponse
   */
  withAirlineTicketUrl?: string | null
  /**
   *
   * @type {string}
   * @memberof PropertyResponse
   */
  hotelArea?: PropertyResponseHotelAreaEnum
  /**
   *
   * @type {string}
   * @memberof PropertyResponse
   */
  reservePeriodStart?: string | null
  /**
   * Whether to show the special-service-request input on the registration form
   * @type {boolean}
   * @memberof PropertyResponse
   */
  showSpecialServiceRequest?: boolean
  /**
   * Whether to show the company name input on the registration form
   * @type {boolean}
   * @memberof PropertyResponse
   */
  showCompanyName?: boolean
  /**
   * Whether to show the purpose-of-use input on the registration form
   * @type {boolean}
   * @memberof PropertyResponse
   */
  showPurposeOfUse?: boolean
  /**
   * Whether to show the check-in time input on the registration form
   * @type {boolean}
   * @memberof PropertyResponse
   */
  showCheckInTime?: boolean
}

export const PropertyResponseHotelAreaEnum = {
  Fvillage: 'fvillage',
  Kitahiroshima: 'kitahiroshima',
  Sapporo: 'sapporo',
  Chitose: 'chitose',
  Shinsapporo: 'shinsapporo',
} as const

export type PropertyResponseHotelAreaEnum =
  (typeof PropertyResponseHotelAreaEnum)[keyof typeof PropertyResponseHotelAreaEnum]

/**
 * Publication
 * @export
 * @interface PublicationResponse
 */
export interface PublicationResponse {
  /**
   *
   * @type {number}
   * @memberof PublicationResponse
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof PublicationResponse
   */
  locale?: string
  /**
   *
   * @type {string}
   * @memberof PublicationResponse
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof PublicationResponse
   */
  shortName?: string
  /**
   *
   * @type {string}
   * @memberof PublicationResponse
   */
  description?: string
  /**
   *
   * @type {string}
   * @memberof PublicationResponse
   */
  descriptionDetail?: string
  /**
   * Address
   * @type {string}
   * @memberof PublicationResponse
   */
  access?: string
  /**
   * Pricing
   * @type {string}
   * @memberof PublicationResponse
   */
  pricing?: string
  /**
   * Information
   * @type {string}
   * @memberof PublicationResponse
   */
  information?: string
  /**
   * Recommendation
   * @type {string}
   * @memberof PublicationResponse
   */
  recommendation?: string
}
/**
 *
 * @export
 * @interface ReceiptDownloadResponse
 */
export interface ReceiptDownloadResponse {
  /**
   *
   * @type {number}
   * @memberof ReceiptDownloadResponse
   */
  displayCount?: number
  /**
   *
   * @type {number}
   * @memberof ReceiptDownloadResponse
   */
  maxDisplayCount?: number
  /**
   *
   * @type {string}
   * @memberof ReceiptDownloadResponse
   */
  signedUrl: string
}
/**
 *
 * @export
 * @interface ReservationReceiptResponse
 */
export interface ReservationReceiptResponse {
  /**
   *
   * @type {number}
   * @memberof ReservationReceiptResponse
   */
  displayCount?: number
  /**
   *
   * @type {number}
   * @memberof ReservationReceiptResponse
   */
  maxDisplayCount?: number
  /**
   *
   * @type {number}
   * @memberof ReservationReceiptResponse
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ReservationReceiptResponse
   */
  paidAt: string
  /**
   *
   * @type {string}
   * @memberof ReservationReceiptResponse
   */
  url: string
}
/**
 * Reservation
 * @export
 * @interface ReservationResponse
 */
export interface ReservationResponse {
  /**
   * Valid receipts with an uploaded PDF
   * @type {Array<ReservationReceiptResponse>}
   * @memberof ReservationResponse
   */
  receipts?: Array<ReservationReceiptResponse>
  /**
   * Reservation id
   * @type {number}
   * @memberof ReservationResponse
   */
  id?: number
  /**
   * Confirmation code
   * @type {string}
   * @memberof ReservationResponse
   */
  confirmationCode?: string
  /**
   * Reservation created at(`ISO 8601`)
   * @type {string}
   * @memberof ReservationResponse
   */
  bookedAt?: string
  /**
   * Cancellation createds at(`ISO 8601`)
   * @type {string}
   * @memberof ReservationResponse
   */
  cancelledAt?: string | null
  /**
   * Is canceled
   * @type {boolean}
   * @memberof ReservationResponse
   */
  isCancelled?: boolean
  /**
   * QR code list
   * @type {string}
   * @memberof ReservationResponse
   */
  qrCodeListUrl?: string | null
  /**
   * Advanced check-in URL
   * @type {string}
   * @memberof ReservationResponse
   */
  advancedCheckedInGuestUrl?: string | null
  /**
   * Guest status   * 1 - Pre arrival   * 2 - Check-in day   * 3 - Stay   * 4 - Check-out day   * 5 - Departure   * 6 - No show   * 7 - Canceled by property   * 8 - Canceled by guest
   * @type {number}
   * @memberof ReservationResponse
   */
  guestStatus?: ReservationResponseGuestStatusEnum
  /**
   *
   * @type {TransactionResponse}
   * @memberof ReservationResponse
   */
  transaction?: TransactionResponse
}

export const ReservationResponseGuestStatusEnum = {
  PreArrival: 1,
  CheckInDay: 2,
  Stay: 3,
  CheckOutDay: 4,
  Departure: 5,
  NoShow: 6,
  CanceledByProperty: 7,
  CanceledByGuest: 8,
} as const

export type ReservationResponseGuestStatusEnum =
  (typeof ReservationResponseGuestStatusEnum)[keyof typeof ReservationResponseGuestStatusEnum]

/**
 *
 * @export
 * @interface ReservationsResponse
 */
export interface ReservationsResponse {
  /**
   *
   * @type {number}
   * @memberof ReservationsResponse
   */
  count?: number
  /**
   *
   * @type {string}
   * @memberof ReservationsResponse
   */
  next?: string | null
  /**
   *
   * @type {string}
   * @memberof ReservationsResponse
   */
  previous?: string | null
  /**
   *
   * @type {Array<ReservationResponse>}
   * @memberof ReservationsResponse
   */
  results?: Array<ReservationResponse>
}
/**
 * Room Daily Availability
 * @export
 * @interface RoomDailyAvailability
 */
export interface RoomDailyAvailability {
  /**
   *
   * @type {string}
   * @memberof RoomDailyAvailability
   */
  date?: string
  /**
   *
   * @type {number}
   * @memberof RoomDailyAvailability
   */
  availableCount?: number
}
/**
 * Room category
 * @export
 * @interface RoomResponse
 */
export interface RoomResponse {
  /**
   *
   * @type {number}
   * @memberof RoomResponse
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  slug: string
  /**
   *
   * @type {number}
   * @memberof RoomResponse
   */
  minPrice: number
  /**
   *
   * @type {number}
   * @memberof RoomResponse
   */
  listing: number
  /**
   *
   * @type {number}
   * @memberof RoomResponse
   */
  roomSize: number
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  roomSizeUnit: string
  /**
   *
   * @type {number}
   * @memberof RoomResponse
   */
  maxPax: number
  /**
   *
   * @type {number}
   * @memberof RoomResponse
   */
  minPax: number
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  roomCategory: string
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  roomType: string
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  grade: string
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  equipment: string
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  amenity: string
  /**
   *
   * @type {string}
   * @memberof RoomResponse
   */
  feature: string
  /**
   *
   * @type {Array<ImageResponse>}
   * @memberof RoomResponse
   */
  images?: Array<ImageResponse>
  /**
   *
   * @type {Array<BookingEngineRoomPublication>}
   * @memberof RoomResponse
   */
  publications?: Array<BookingEngineRoomPublication>
  /**
   *
   * @type {boolean}
   * @memberof RoomResponse
   */
  canReserve: boolean
  /**
   * Whether accommodation tax is collected on site
   * @type {boolean}
   * @memberof RoomResponse
   */
  collectAccommodationTaxOnSite: boolean
  /**
   * Whether bath tax is collected on site
   * @type {boolean}
   * @memberof RoomResponse
   */
  collectBathTaxOnSite: boolean
}
/**
 * Stok
 * @export
 * @interface StockResponse
 */
export interface StockResponse {
  /**
   *
   * @type {number}
   * @memberof StockResponse
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof StockResponse
   */
  date?: string
  /**
   *
   * @type {number}
   * @memberof StockResponse
   */
  availableStock?: number
}
/**
 * Tax
 * @export
 * @interface Tax
 */
export interface Tax {
  /**
   * Tax rate
   * @type {number}
   * @memberof Tax
   */
  taxRate?: number
  /**
   * Tax
   * @type {number}
   * @memberof Tax
   */
  taxAmount?: number
}
/**
 *
 * @export
 * @interface TokenCheck
 */
export interface TokenCheck {
  /**
   *
   * @type {boolean}
   * @memberof TokenCheck
   */
  valid?: boolean
  /**
   *
   * @type {string}
   * @memberof TokenCheck
   */
  reason?: string | null
}
/**
 * Input of registration
 * @export
 * @interface TransactionInput
 */
export interface TransactionInput {
  /**
   *
   * @type {BookingEngineHotel}
   * @memberof TransactionInput
   */
  bookingEngineHotel?: BookingEngineHotel
  /**
   *
   * @type {OverViewRoom}
   * @memberof TransactionInput
   */
  bookingEngineRoom?: OverViewRoom
  /**
   *
   * @type {OverViewPlan}
   * @memberof TransactionInput
   */
  bookingEnginePlan?: OverViewPlan
  /**
   *
   * @type {Array<OverViewOption>}
   * @memberof TransactionInput
   */
  options?: Array<OverViewOption>
  /**
   * Saved option answer snapshots in creation order. An empty array means no saved answers.
   * @type {Array<TransactionInputOptionAnswerResponse>}
   * @memberof TransactionInput
   */
  optionAnswers?: Array<TransactionInputOptionAnswerResponse>
  /**
   *
   * @type {TransactionInputCancelPolicy}
   * @memberof TransactionInput
   */
  cancelPolicy?: TransactionInputCancelPolicy | null
  /**
   * Number of adults
   * @type {number}
   * @memberof TransactionInput
   */
  numberOfAdults?: number
  /**
   * Number of children
   * @type {number}
   * @memberof TransactionInput
   */
  numberOfChildren?: number
  /**
   * Number of infants
   * @type {number}
   * @memberof TransactionInput
   */
  numberOfInfants?: number
  /**
   * Check-in date(`yyyy-MM-dd`)
   * @type {string}
   * @memberof TransactionInput
   */
  checkInDate?: string
  /**
   * Check-out date(`yyyy-MM-dd`)
   * @type {string}
   * @memberof TransactionInput
   */
  checkOutDate?: string
  /**
   * Number of room counts
   * @type {number}
   * @memberof TransactionInput
   */
  roomCount?: number
  /**
   * Name
   * @type {string}
   * @memberof TransactionInput
   */
  name?: string
  /**
   * Kana
   * @type {string}
   * @memberof TransactionInput
   */
  kana?: string
  /**
   * Phone
   * @type {string}
   * @memberof TransactionInput
   */
  phone?: string
  /**
   * Mail address
   * @type {string}
   * @memberof TransactionInput
   */
  email?: string
  /**
   * Postal code
   * @type {string}
   * @memberof TransactionInput
   */
  postalCode?: string
  /**
   * Address
   * @type {string}
   * @memberof TransactionInput
   */
  address?: string
  /**
   * Birth day
   * @type {string}
   * @memberof TransactionInput
   */
  dateOfBirth?: string
  /**
   * Room price
   * @type {number}
   * @memberof TransactionInput
   */
  roomPrice?: number
  /**
   * Option price
   * @type {number}
   * @memberof TransactionInput
   */
  optionPrice?: number | null
  /**
   * Option price
   * @type {number}
   * @memberof TransactionInput
   */
  discountPrice?: number | null
  /**
   * taxes
   * @type {Array<Tax>}
   * @memberof TransactionInput
   */
  taxes?: Array<Tax>
  /**
   * Total tax
   * @type {number}
   * @memberof TransactionInput
   */
  totalTaxAmount?: number
  /**
   * Total(tax exclude)
   * @type {number}
   * @memberof TransactionInput
   */
  totalPriceExcludingTax?: number
  /**
   * Total(tax include)
   * @type {number}
   * @memberof TransactionInput
   */
  totalPrice?: number
  /**
   * Whether accommodation tax is collected on site
   * @type {boolean}
   * @memberof TransactionInput
   */
  collectAccommodationTaxOnSite?: boolean
  /**
   * Whether bath tax is collected on site
   * @type {boolean}
   * @memberof TransactionInput
   */
  collectBathTaxOnSite?: boolean
  /**
   * Company name (lounge inquiry)
   * @type {string}
   * @memberof TransactionInput
   */
  companyName?: string | null
  /**
   * Purpose of use (lounge inquiry)
   * @type {string}
   * @memberof TransactionInput
   */
  purposeOfUse?: string | null
  /**
   * Check-in time(`HH:mm`) (lounge inquiry)
   * @type {string}
   * @memberof TransactionInput
   */
  checkInTime?: string | null
  /**
   * Invoice addressee name (INVOICE payment plans)
   * @type {string}
   * @memberof TransactionInput
   */
  invoiceAddressee?: string | null
}
/**
 *
 * @export
 * @interface TransactionInputCancelPolicy
 */
export interface TransactionInputCancelPolicy {
  /**
   *
   * @type {number}
   * @memberof TransactionInputCancelPolicy
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof TransactionInputCancelPolicy
   */
  name?: string
  /**
   *
   * @type {boolean}
   * @memberof TransactionInputCancelPolicy
   */
  nonRefundable?: boolean
  /**
   *
   * @type {boolean}
   * @memberof TransactionInputCancelPolicy
   */
  needsDeposit?: boolean
  /**
   *
   * @type {number}
   * @memberof TransactionInputCancelPolicy
   */
  noShowRate?: number | null
  /**
   *
   * @type {number}
   * @memberof TransactionInputCancelPolicy
   */
  cancellationTodayRate?: number | null
  /**
   *
   * @type {Array<AdditionalCasesResponse>}
   * @memberof TransactionInputCancelPolicy
   */
  additionalCases?: Array<AdditionalCasesResponse>
}
/**
 * Saved option answer snapshot, independent of current input fields.
 * @export
 * @interface TransactionInputOptionAnswerResponse
 */
export interface TransactionInputOptionAnswerResponse {
  /**
   *
   * @type {number}
   * @memberof TransactionInputOptionAnswerResponse
   */
  id: number
  /**
   *
   * @type {number}
   * @memberof TransactionInputOptionAnswerResponse
   */
  option: number
  /**
   *
   * @type {string}
   * @memberof TransactionInputOptionAnswerResponse
   */
  label: string
  /**
   *
   * @type {string}
   * @memberof TransactionInputOptionAnswerResponse
   */
  value: string
}
/**
 * Transaction
 * @export
 * @interface TransactionResponse
 */
export interface TransactionResponse {
  /**
   * Id
   * @type {number}
   * @memberof TransactionResponse
   */
  id?: number
  /**
   *
   * @type {TransactionInput}
   * @memberof TransactionResponse
   */
  input?: TransactionInput
  /**
   * Reservation ID
   * @type {number}
   * @memberof TransactionResponse
   */
  reservationId?: number | null
}
/**
 *
 * @export
 * @interface UpdateTransactionInputRequest
 */
export interface UpdateTransactionInputRequest {
  /**
   * Guest name
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  name?: string
  /**
   * Guest name kana
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  kana?: string
  /**
   * Guest phone number
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  phone?: string
  /**
   * Guest Email
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  email?: string
  /**
   * Guest postal code
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  postalCode?: string
  /**
   * Guest address
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  address?: string
  /**
   * Date of birth(`yyyy-MM-dd`)
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  dateOfBirth?: string
  /**
   * Inquiry
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  specialServiceRequest?: string
  /**
   * Company name (lounge inquiry)
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  companyName?: string | null
  /**
   * Purpose of use (lounge inquiry)
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  purposeOfUse?: string | null
  /**
   * Check-in time(`HH:mm`) (lounge inquiry)
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  checkInTime?: string | null
  /**
   * Invoice addressee name, required when the plan payment type is INVOICE
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  invoiceAddressee?: string | null
  /**
   * GMO payment token
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  gmoToken?: string
  /**
   * GMO payment token expired at(`yyyy-MM-dd-HH-mm-ss`)
   * @type {string}
   * @memberof UpdateTransactionInputRequest
   */
  gmoTokenExpiredAt?: string
}

/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authTokenCheck: async (
      logoutRequest?: LogoutRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/token/check`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        logoutRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get Fid auth token
     * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authTokenFid: async (
      authTokenGoogleRequest?: AuthTokenGoogleRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/token/fid`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        authTokenGoogleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get google auth token
     * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authTokenGoogle: async (
      authTokenGoogleRequest?: AuthTokenGoogleRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/token/google`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        authTokenGoogleRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout: async (
      logoutRequest?: LogoutRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/logout`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        logoutRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    me: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authTokenCheck(
      logoutRequest?: LogoutRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenCheck>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authTokenCheck(
        logoutRequest,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get Fid auth token
     * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authTokenFid(
      authTokenGoogleRequest?: AuthTokenGoogleRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthTokenResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authTokenFid(
        authTokenGoogleRequest,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get google auth token
     * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authTokenGoogle(
      authTokenGoogleRequest?: AuthTokenGoogleRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthTokenResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.authTokenGoogle(
        authTokenGoogleRequest,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logout(
      logoutRequest?: LogoutRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logout(
        logoutRequest,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async me(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<AuthTokenResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.me(options)
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
  }
}

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AuthApiFp(configuration)
  return {
    /**
     *
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authTokenCheck(
      logoutRequest?: LogoutRequest,
      options?: any
    ): AxiosPromise<TokenCheck> {
      return localVarFp
        .authTokenCheck(logoutRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get Fid auth token
     * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authTokenFid(
      authTokenGoogleRequest?: AuthTokenGoogleRequest,
      options?: any
    ): AxiosPromise<AuthTokenResponse> {
      return localVarFp
        .authTokenFid(authTokenGoogleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get google auth token
     * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authTokenGoogle(
      authTokenGoogleRequest?: AuthTokenGoogleRequest,
      options?: any
    ): AxiosPromise<AuthTokenResponse> {
      return localVarFp
        .authTokenGoogle(authTokenGoogleRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(logoutRequest?: LogoutRequest, options?: any): AxiosPromise<object> {
      return localVarFp
        .logout(logoutRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get user information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    me(options?: any): AxiosPromise<AuthTokenResponse> {
      return localVarFp.me(options).then((request) => request(axios, basePath))
    },
  }
}

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
  /**
   *
   * @param {LogoutRequest} [logoutRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApiInterface
   */
  authTokenCheck(
    logoutRequest?: LogoutRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<TokenCheck>

  /**
   * Get Fid auth token
   * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApiInterface
   */
  authTokenFid(
    authTokenGoogleRequest?: AuthTokenGoogleRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<AuthTokenResponse>

  /**
   * Get google auth token
   * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApiInterface
   */
  authTokenGoogle(
    authTokenGoogleRequest?: AuthTokenGoogleRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<AuthTokenResponse>

  /**
   * Logout
   * @param {LogoutRequest} [logoutRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApiInterface
   */
  logout(
    logoutRequest?: LogoutRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<object>

  /**
   * Get user information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApiInterface
   */
  me(options?: AxiosRequestConfig): AxiosPromise<AuthTokenResponse>
}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
  /**
   *
   * @param {LogoutRequest} [logoutRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authTokenCheck(
    logoutRequest?: LogoutRequest,
    options?: AxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authTokenCheck(logoutRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get Fid auth token
   * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authTokenFid(
    authTokenGoogleRequest?: AuthTokenGoogleRequest,
    options?: AxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authTokenFid(authTokenGoogleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get google auth token
   * @param {AuthTokenGoogleRequest} [authTokenGoogleRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public authTokenGoogle(
    authTokenGoogleRequest?: AuthTokenGoogleRequest,
    options?: AxiosRequestConfig
  ) {
    return AuthApiFp(this.configuration)
      .authTokenGoogle(authTokenGoogleRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Logout
   * @param {LogoutRequest} [logoutRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public logout(logoutRequest?: LogoutRequest, options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .logout(logoutRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get user information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthApi
   */
  public me(options?: AxiosRequestConfig) {
    return AuthApiFp(this.configuration)
      .me(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NewsApi - axios parameter creator
 * @export
 */
export const NewsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Get news of the specified hotel
     * @param {string} propertySlug Hotel slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelNews: async (
      propertySlug: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('getHotelNews', 'propertySlug', propertySlug)
      const localVarPath = `/hotels/{property_slug}/news`.replace(
        `{${'property_slug'}}`,
        encodeURIComponent(String(propertySlug))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get news
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNews: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/news`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * NewsApi - functional programming interface
 * @export
 */
export const NewsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = NewsApiAxiosParamCreator(configuration)
  return {
    /**
     * Get news of the specified hotel
     * @param {string} propertySlug Hotel slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHotelNews(
      propertySlug: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<BookingEngineNews>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHotelNews(
        propertySlug,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get news
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNews(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<BookingEngineNews>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getNews(options)
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
  }
}

/**
 * NewsApi - factory interface
 * @export
 */
export const NewsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NewsApiFp(configuration)
  return {
    /**
     * Get news of the specified hotel
     * @param {string} propertySlug Hotel slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelNews(
      propertySlug: string,
      options?: any
    ): AxiosPromise<BookingEngineNews> {
      return localVarFp
        .getHotelNews(propertySlug, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get news
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNews(options?: any): AxiosPromise<BookingEngineNews> {
      return localVarFp
        .getNews(options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * NewsApi - interface
 * @export
 * @interface NewsApi
 */
export interface NewsApiInterface {
  /**
   * Get news of the specified hotel
   * @param {string} propertySlug Hotel slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsApiInterface
   */
  getHotelNews(
    propertySlug: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<BookingEngineNews>

  /**
   * Get news
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsApiInterface
   */
  getNews(options?: AxiosRequestConfig): AxiosPromise<BookingEngineNews>
}

/**
 * NewsApi - object-oriented interface
 * @export
 * @class NewsApi
 * @extends {BaseAPI}
 */
export class NewsApi extends BaseAPI implements NewsApiInterface {
  /**
   * Get news of the specified hotel
   * @param {string} propertySlug Hotel slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsApi
   */
  public getHotelNews(propertySlug: string, options?: AxiosRequestConfig) {
    return NewsApiFp(this.configuration)
      .getHotelNews(propertySlug, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get news
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NewsApi
   */
  public getNews(options?: AxiosRequestConfig) {
    return NewsApiFp(this.configuration)
      .getNews(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Get all notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/notifications`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    NotificationApiAxiosParamCreator(configuration)
  return {
    /**
     * Get all notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getNotifications(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<BookingEngineNotification>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getNotifications(options)
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
  }
}

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = NotificationApiFp(configuration)
  return {
    /**
     * Get all notifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getNotifications(
      options?: any
    ): AxiosPromise<Array<BookingEngineNotification>> {
      return localVarFp
        .getNotifications(options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * NotificationApi - interface
 * @export
 * @interface NotificationApi
 */
export interface NotificationApiInterface {
  /**
   * Get all notifications
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApiInterface
   */
  getNotifications(
    options?: AxiosRequestConfig
  ): AxiosPromise<Array<BookingEngineNotification>>
}

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi
  extends BaseAPI
  implements NotificationApiInterface
{
  /**
   * Get all notifications
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof NotificationApi
   */
  public getNotifications(options?: AxiosRequestConfig) {
    return NotificationApiFp(this.configuration)
      .getNotifications(options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * PropertyApi - axios parameter creator
 * @export
 */
export const PropertyApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Get availability status for the specified hotel
     * @param {string} slug Hotel slug
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
     * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelAvailabilities: async (
      slug: string,
      fromDate?: string,
      toDate?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'slug' is not null or undefined
      assertParamExists('getHotelAvailabilities', 'slug', slug)
      const localVarPath = `/hotels/{slug}/availabilities`.replace(
        `{${'slug'}}`,
        encodeURIComponent(String(slug))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (fromDate !== undefined) {
        localVarQueryParameter['from_date'] =
          (fromDate as any) instanceof Date
            ? (fromDate as any).toISOString().substr(0, 10)
            : fromDate
      }

      if (toDate !== undefined) {
        localVarQueryParameter['to_date'] =
          (toDate as any) instanceof Date
            ? (toDate as any).toISOString().substr(0, 10)
            : toDate
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get detailed information for the specified hotel
     * @param {string} slug Hotel slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelDetail: async (
      slug: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'slug' is not null or undefined
      assertParamExists('getHotelDetail', 'slug', slug)
      const localVarPath = `/hotels/{slug}/details`.replace(
        `{${'slug'}}`,
        encodeURIComponent(String(slug))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List the facility\'s public plans (no room scope). Secret plans are excluded. Each plan carries a single representative price (the cheapest reservable listing) and canReserve is true when any hosting listing is bookable. Used by the plan-first landing page (/:property/plans).
     * @param {string} propertySlug
     * @param {string} [checkInDate]
     * @param {string} [checkOutDate]
     * @param {number} [roomCount]
     * @param {number} [numberOfAdults]
     * @param {number} [numberOfChildren]
     * @param {number} [numberOfInfants]
     * @param {boolean} [showAllPlans] show all plans or can reserve plans
     * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * Default: &#x60;recommendation&#x60;(Order by recommendation)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelPlans: async (
      propertySlug: string,
      checkInDate?: string,
      checkOutDate?: string,
      roomCount?: number,
      numberOfAdults?: number,
      numberOfChildren?: number,
      numberOfInfants?: number,
      showAllPlans?: boolean,
      order?: 'price' | '-price' | 'recommendation',
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('getHotelPlans', 'propertySlug', propertySlug)
      const localVarPath = `/hotels/{property_slug}/plans`.replace(
        `{${'property_slug'}}`,
        encodeURIComponent(String(propertySlug))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (checkInDate !== undefined) {
        localVarQueryParameter['check_in_date'] = checkInDate
      }

      if (checkOutDate !== undefined) {
        localVarQueryParameter['check_out_date'] = checkOutDate
      }

      if (roomCount !== undefined) {
        localVarQueryParameter['room_count'] = roomCount
      }

      if (numberOfAdults !== undefined) {
        localVarQueryParameter['number_of_adults'] = numberOfAdults
      }

      if (numberOfChildren !== undefined) {
        localVarQueryParameter['number_of_children'] = numberOfChildren
      }

      if (numberOfInfants !== undefined) {
        localVarQueryParameter['number_of_infants'] = numberOfInfants
      }

      if (showAllPlans !== undefined) {
        localVarQueryParameter['show_all_plans'] = showAllPlans
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a list of hotels with room types available for reservation
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount Room count
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {boolean} [isHotel] Is hotel or not
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {'order' | '-order' | 'distance' | '-distance' | 'min_price' | '-min_price'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelRooms: async (
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      offset?: number,
      limit?: number,
      isHotel?: boolean,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      order?:
        | 'order'
        | '-order'
        | 'distance'
        | '-distance'
        | 'min_price'
        | '-min_price',
      showAllRooms?: boolean,
      equipments?: Array<
        | 'no_smoking'
        | 'smoking'
        | 'free_wifi'
        | 'parking'
        | 'spa'
        | 'restaurant'
        | 'pets_allowed'
        | 'family'
      >,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'checkInDate' is not null or undefined
      assertParamExists('getHotelRooms', 'checkInDate', checkInDate)
      // verify required parameter 'checkOutDate' is not null or undefined
      assertParamExists('getHotelRooms', 'checkOutDate', checkOutDate)
      // verify required parameter 'roomCount' is not null or undefined
      assertParamExists('getHotelRooms', 'roomCount', roomCount)
      // verify required parameter 'numberOfAdults' is not null or undefined
      assertParamExists('getHotelRooms', 'numberOfAdults', numberOfAdults)
      // verify required parameter 'numberOfChildren' is not null or undefined
      assertParamExists('getHotelRooms', 'numberOfChildren', numberOfChildren)
      // verify required parameter 'numberOfInfants' is not null or undefined
      assertParamExists('getHotelRooms', 'numberOfInfants', numberOfInfants)
      const localVarPath = `/hotels/rooms`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (checkInDate !== undefined) {
        localVarQueryParameter['check_in_date'] =
          (checkInDate as any) instanceof Date
            ? (checkInDate as any).toISOString().substr(0, 10)
            : checkInDate
      }

      if (checkOutDate !== undefined) {
        localVarQueryParameter['check_out_date'] =
          (checkOutDate as any) instanceof Date
            ? (checkOutDate as any).toISOString().substr(0, 10)
            : checkOutDate
      }

      if (roomCount !== undefined) {
        localVarQueryParameter['room_count'] = roomCount
      }

      if (numberOfAdults !== undefined) {
        localVarQueryParameter['number_of_adults'] = numberOfAdults
      }

      if (numberOfChildren !== undefined) {
        localVarQueryParameter['number_of_children'] = numberOfChildren
      }

      if (numberOfInfants !== undefined) {
        localVarQueryParameter['number_of_infants'] = numberOfInfants
      }

      if (isHotel !== undefined) {
        localVarQueryParameter['is_hotel'] = isHotel
      }

      if (insideFvillage !== undefined) {
        localVarQueryParameter['inside_fvillage'] = insideFvillage
      }

      if (hotelAreas) {
        localVarQueryParameter['hotel_areas'] = hotelAreas.join(
          COLLECTION_FORMATS.csv
        )
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (showAllRooms !== undefined) {
        localVarQueryParameter['show_all_rooms'] = showAllRooms
      }

      if (equipments) {
        localVarQueryParameter['equipments'] = equipments.join(
          COLLECTION_FORMATS.csv
        )
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get plan
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlan: async (
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('getPlan', 'propertySlug', propertySlug)
      // verify required parameter 'roomSlug' is not null or undefined
      assertParamExists('getPlan', 'roomSlug', roomSlug)
      // verify required parameter 'planSlug' is not null or undefined
      assertParamExists('getPlan', 'planSlug', planSlug)
      const localVarPath =
        `/hotels/{property_slug}/rooms/{room_slug}/plans/{plan_slug}`
          .replace(
            `{${'property_slug'}}`,
            encodeURIComponent(String(propertySlug))
          )
          .replace(`{${'room_slug'}}`, encodeURIComponent(String(roomSlug)))
          .replace(`{${'plan_slug'}}`, encodeURIComponent(String(planSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get a plan (indexed by plan slug only) with the rooms it is bookable on
     * @param {string} propertySlug
     * @param {string} planSlug
     * @param {string} [checkInDate]
     * @param {string} [checkOutDate]
     * @param {number} [roomCount]
     * @param {number} [numberOfAdults]
     * @param {number} [numberOfChildren]
     * @param {number} [numberOfInfants]
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
     * @param {string} [room] Room slug to limit display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlanWithRooms: async (
      propertySlug: string,
      planSlug: string,
      checkInDate?: string,
      checkOutDate?: string,
      roomCount?: number,
      numberOfAdults?: number,
      numberOfChildren?: number,
      numberOfInfants?: number,
      showAllRooms?: boolean,
      order?: 'min_price' | '-min_price',
      room?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('getPlanWithRooms', 'propertySlug', propertySlug)
      // verify required parameter 'planSlug' is not null or undefined
      assertParamExists('getPlanWithRooms', 'planSlug', planSlug)
      const localVarPath = `/hotels/{property_slug}/plans/{plan_slug}`
        .replace(
          `{${'property_slug'}}`,
          encodeURIComponent(String(propertySlug))
        )
        .replace(`{${'plan_slug'}}`, encodeURIComponent(String(planSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (checkInDate !== undefined) {
        localVarQueryParameter['check_in_date'] = checkInDate
      }

      if (checkOutDate !== undefined) {
        localVarQueryParameter['check_out_date'] = checkOutDate
      }

      if (roomCount !== undefined) {
        localVarQueryParameter['room_count'] = roomCount
      }

      if (numberOfAdults !== undefined) {
        localVarQueryParameter['number_of_adults'] = numberOfAdults
      }

      if (numberOfChildren !== undefined) {
        localVarQueryParameter['number_of_children'] = numberOfChildren
      }

      if (numberOfInfants !== undefined) {
        localVarQueryParameter['number_of_infants'] = numberOfInfants
      }

      if (showAllRooms !== undefined) {
        localVarQueryParameter['show_all_rooms'] = showAllRooms
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (room !== undefined) {
        localVarQueryParameter['room'] = room
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get price
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {number} transactionId Transaction ID
     * @param {string} checkInDate Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} checkOutDate Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {number} roomCount Number of rooms
     * @param {number} numberOfAdults Number of adults
     * @param {number} numberOfChildren Number of children
     * @param {number} numberOfInfants Number of infants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrice: async (
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      transactionId: number,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('getPrice', 'propertySlug', propertySlug)
      // verify required parameter 'roomSlug' is not null or undefined
      assertParamExists('getPrice', 'roomSlug', roomSlug)
      // verify required parameter 'planSlug' is not null or undefined
      assertParamExists('getPrice', 'planSlug', planSlug)
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('getPrice', 'transactionId', transactionId)
      // verify required parameter 'checkInDate' is not null or undefined
      assertParamExists('getPrice', 'checkInDate', checkInDate)
      // verify required parameter 'checkOutDate' is not null or undefined
      assertParamExists('getPrice', 'checkOutDate', checkOutDate)
      // verify required parameter 'roomCount' is not null or undefined
      assertParamExists('getPrice', 'roomCount', roomCount)
      // verify required parameter 'numberOfAdults' is not null or undefined
      assertParamExists('getPrice', 'numberOfAdults', numberOfAdults)
      // verify required parameter 'numberOfChildren' is not null or undefined
      assertParamExists('getPrice', 'numberOfChildren', numberOfChildren)
      // verify required parameter 'numberOfInfants' is not null or undefined
      assertParamExists('getPrice', 'numberOfInfants', numberOfInfants)
      const localVarPath =
        `/hotels/{property_slug}/rooms/{room_slug}/plans/{plan_slug}/price`
          .replace(
            `{${'property_slug'}}`,
            encodeURIComponent(String(propertySlug))
          )
          .replace(`{${'room_slug'}}`, encodeURIComponent(String(roomSlug)))
          .replace(`{${'plan_slug'}}`, encodeURIComponent(String(planSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (transactionId !== undefined) {
        localVarQueryParameter['transaction_id'] = transactionId
      }

      if (checkInDate !== undefined) {
        localVarQueryParameter['check_in_date'] =
          (checkInDate as any) instanceof Date
            ? (checkInDate as any).toISOString().substr(0, 10)
            : checkInDate
      }

      if (checkOutDate !== undefined) {
        localVarQueryParameter['check_out_date'] =
          (checkOutDate as any) instanceof Date
            ? (checkOutDate as any).toISOString().substr(0, 10)
            : checkOutDate
      }

      if (roomCount !== undefined) {
        localVarQueryParameter['room_count'] = roomCount
      }

      if (numberOfAdults !== undefined) {
        localVarQueryParameter['number_of_adults'] = numberOfAdults
      }

      if (numberOfChildren !== undefined) {
        localVarQueryParameter['number_of_children'] = numberOfChildren
      }

      if (numberOfInfants !== undefined) {
        localVarQueryParameter['number_of_infants'] = numberOfInfants
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get property
     * @param {string} slug Building slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProperty: async (
      slug: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'slug' is not null or undefined
      assertParamExists('getProperty', 'slug', slug)
      const localVarPath = `/hotels/{slug}`.replace(
        `{${'slug'}}`,
        encodeURIComponent(String(slug))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get property list
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default today
     * @param {string} [toDate] End date (yyyy-MM-dd) default 4 weeks later
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [withPagination] Pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyAvailabilities: async (
      offset?: number,
      limit?: number,
      fromDate?: string,
      toDate?: string,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      order?: 'order' | '-order' | 'distance' | '-distance',
      withPagination?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/hotels/availabilities`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (fromDate !== undefined) {
        localVarQueryParameter['from_date'] =
          (fromDate as any) instanceof Date
            ? (fromDate as any).toISOString().substr(0, 10)
            : fromDate
      }

      if (toDate !== undefined) {
        localVarQueryParameter['to_date'] =
          (toDate as any) instanceof Date
            ? (toDate as any).toISOString().substr(0, 10)
            : toDate
      }

      if (insideFvillage !== undefined) {
        localVarQueryParameter['inside_fvillage'] = insideFvillage
      }

      if (hotelAreas) {
        localVarQueryParameter['hotel_areas'] = hotelAreas.join(
          COLLECTION_FORMATS.csv
        )
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (withPagination !== undefined) {
        localVarQueryParameter['with_pagination'] = withPagination
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get room by slug
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoom: async (
      propertySlug: string,
      roomSlug: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('getRoom', 'propertySlug', propertySlug)
      // verify required parameter 'roomSlug' is not null or undefined
      assertParamExists('getRoom', 'roomSlug', roomSlug)
      const localVarPath = `/hotels/{property_slug}/rooms/{room_slug}`
        .replace(
          `{${'property_slug'}}`,
          encodeURIComponent(String(propertySlug))
        )
        .replace(`{${'room_slug'}}`, encodeURIComponent(String(roomSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get availabilities per room category
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
     * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
     * @param {number} [roomId] Room Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoomAvailabilities: async (
      propertySlug: string,
      roomSlug: string,
      fromDate?: string,
      toDate?: string,
      roomId?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('getRoomAvailabilities', 'propertySlug', propertySlug)
      // verify required parameter 'roomSlug' is not null or undefined
      assertParamExists('getRoomAvailabilities', 'roomSlug', roomSlug)
      const localVarPath =
        `/hotels/{property_slug}/rooms/{room_slug}/availabilities`
          .replace(
            `{${'property_slug'}}`,
            encodeURIComponent(String(propertySlug))
          )
          .replace(`{${'room_slug'}}`, encodeURIComponent(String(roomSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (fromDate !== undefined) {
        localVarQueryParameter['from_date'] =
          (fromDate as any) instanceof Date
            ? (fromDate as any).toISOString().substr(0, 10)
            : fromDate
      }

      if (toDate !== undefined) {
        localVarQueryParameter['to_date'] =
          (toDate as any) instanceof Date
            ? (toDate as any).toISOString().substr(0, 10)
            : toDate
      }

      if (roomId !== undefined) {
        localVarQueryParameter['room_id'] = roomId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List option
     * @param {string} propertySlug Building slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOptions: async (
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('listOptions', 'propertySlug', propertySlug)
      // verify required parameter 'roomSlug' is not null or undefined
      assertParamExists('listOptions', 'roomSlug', roomSlug)
      // verify required parameter 'planSlug' is not null or undefined
      assertParamExists('listOptions', 'planSlug', planSlug)
      // verify required parameter 'checkInDate' is not null or undefined
      assertParamExists('listOptions', 'checkInDate', checkInDate)
      // verify required parameter 'checkOutDate' is not null or undefined
      assertParamExists('listOptions', 'checkOutDate', checkOutDate)
      // verify required parameter 'roomCount' is not null or undefined
      assertParamExists('listOptions', 'roomCount', roomCount)
      // verify required parameter 'numberOfAdults' is not null or undefined
      assertParamExists('listOptions', 'numberOfAdults', numberOfAdults)
      // verify required parameter 'numberOfChildren' is not null or undefined
      assertParamExists('listOptions', 'numberOfChildren', numberOfChildren)
      // verify required parameter 'numberOfInfants' is not null or undefined
      assertParamExists('listOptions', 'numberOfInfants', numberOfInfants)
      const localVarPath =
        `/hotels/{property_slug}/rooms/{room_slug}/plans/{plan_slug}/options`
          .replace(
            `{${'property_slug'}}`,
            encodeURIComponent(String(propertySlug))
          )
          .replace(`{${'room_slug'}}`, encodeURIComponent(String(roomSlug)))
          .replace(`{${'plan_slug'}}`, encodeURIComponent(String(planSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (checkInDate !== undefined) {
        localVarQueryParameter['check_in_date'] = checkInDate
      }

      if (checkOutDate !== undefined) {
        localVarQueryParameter['check_out_date'] = checkOutDate
      }

      if (roomCount !== undefined) {
        localVarQueryParameter['room_count'] = roomCount
      }

      if (numberOfAdults !== undefined) {
        localVarQueryParameter['number_of_adults'] = numberOfAdults
      }

      if (numberOfChildren !== undefined) {
        localVarQueryParameter['number_of_children'] = numberOfChildren
      }

      if (numberOfInfants !== undefined) {
        localVarQueryParameter['number_of_infants'] = numberOfInfants
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List plans
     * @param {string} propertySlug Building slug
     * @param {string} roomSlug Room category slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * default: &#x60;recommendation&#x60;(Order by recommendation)
     * @param {boolean} [showAllPlans] show all plans or can reserve plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPlans: async (
      propertySlug: string,
      roomSlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      order?: 'price' | '-price' | 'recommendation',
      showAllPlans?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('listPlans', 'propertySlug', propertySlug)
      // verify required parameter 'roomSlug' is not null or undefined
      assertParamExists('listPlans', 'roomSlug', roomSlug)
      // verify required parameter 'checkInDate' is not null or undefined
      assertParamExists('listPlans', 'checkInDate', checkInDate)
      // verify required parameter 'checkOutDate' is not null or undefined
      assertParamExists('listPlans', 'checkOutDate', checkOutDate)
      // verify required parameter 'roomCount' is not null or undefined
      assertParamExists('listPlans', 'roomCount', roomCount)
      // verify required parameter 'numberOfAdults' is not null or undefined
      assertParamExists('listPlans', 'numberOfAdults', numberOfAdults)
      // verify required parameter 'numberOfChildren' is not null or undefined
      assertParamExists('listPlans', 'numberOfChildren', numberOfChildren)
      // verify required parameter 'numberOfInfants' is not null or undefined
      assertParamExists('listPlans', 'numberOfInfants', numberOfInfants)
      const localVarPath = `/hotels/{property_slug}/rooms/{room_slug}/plans`
        .replace(
          `{${'property_slug'}}`,
          encodeURIComponent(String(propertySlug))
        )
        .replace(`{${'room_slug'}}`, encodeURIComponent(String(roomSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (checkInDate !== undefined) {
        localVarQueryParameter['check_in_date'] = checkInDate
      }

      if (checkOutDate !== undefined) {
        localVarQueryParameter['check_out_date'] = checkOutDate
      }

      if (roomCount !== undefined) {
        localVarQueryParameter['room_count'] = roomCount
      }

      if (numberOfAdults !== undefined) {
        localVarQueryParameter['number_of_adults'] = numberOfAdults
      }

      if (numberOfChildren !== undefined) {
        localVarQueryParameter['number_of_children'] = numberOfChildren
      }

      if (numberOfInfants !== undefined) {
        localVarQueryParameter['number_of_infants'] = numberOfInfants
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (showAllPlans !== undefined) {
        localVarQueryParameter['show_all_plans'] = showAllPlans
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List properties
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {boolean} [isHotel] Is hotel or not
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
     * @param {number} [minPrice] Min price
     * @param {number} [maxPrice] Max price
     * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [withPagination] Pagination
     * @param {boolean} [isSecret] Is secret or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProperties: async (
      offset?: number,
      limit?: number,
      isHotel?: boolean,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      equipments?: Array<
        | 'no_smoking'
        | 'smoking'
        | 'free_wifi'
        | 'parking'
        | 'spa'
        | 'restaurant'
        | 'pets_allowed'
        | 'family'
      >,
      minPrice?: number,
      maxPrice?: number,
      order?: 'order' | '-order' | 'distance' | '-distance',
      withPagination?: boolean,
      isSecret?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/hotels`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication AuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (isHotel !== undefined) {
        localVarQueryParameter['is_hotel'] = isHotel
      }

      if (insideFvillage !== undefined) {
        localVarQueryParameter['inside_fvillage'] = insideFvillage
      }

      if (hotelAreas) {
        localVarQueryParameter['hotel_areas'] = hotelAreas.join(
          COLLECTION_FORMATS.csv
        )
      }

      if (equipments) {
        localVarQueryParameter['equipments'] = equipments.join(
          COLLECTION_FORMATS.csv
        )
      }

      if (minPrice !== undefined) {
        localVarQueryParameter['min_price'] = minPrice
      }

      if (maxPrice !== undefined) {
        localVarQueryParameter['max_price'] = maxPrice
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (withPagination !== undefined) {
        localVarQueryParameter['with_pagination'] = withPagination
      }

      if (isSecret !== undefined) {
        localVarQueryParameter['is_secret'] = isSecret
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * List rooms
     * @param {string} propertySlug Property slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {string} [room] Room slug to limit display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRooms: async (
      propertySlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      order?: 'min_price' | '-min_price',
      showAllRooms?: boolean,
      room?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('listRooms', 'propertySlug', propertySlug)
      // verify required parameter 'checkInDate' is not null or undefined
      assertParamExists('listRooms', 'checkInDate', checkInDate)
      // verify required parameter 'checkOutDate' is not null or undefined
      assertParamExists('listRooms', 'checkOutDate', checkOutDate)
      // verify required parameter 'roomCount' is not null or undefined
      assertParamExists('listRooms', 'roomCount', roomCount)
      // verify required parameter 'numberOfAdults' is not null or undefined
      assertParamExists('listRooms', 'numberOfAdults', numberOfAdults)
      // verify required parameter 'numberOfChildren' is not null or undefined
      assertParamExists('listRooms', 'numberOfChildren', numberOfChildren)
      // verify required parameter 'numberOfInfants' is not null or undefined
      assertParamExists('listRooms', 'numberOfInfants', numberOfInfants)
      const localVarPath = `/hotels/{property_slug}/rooms`.replace(
        `{${'property_slug'}}`,
        encodeURIComponent(String(propertySlug))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (checkInDate !== undefined) {
        localVarQueryParameter['check_in_date'] = checkInDate
      }

      if (checkOutDate !== undefined) {
        localVarQueryParameter['check_out_date'] = checkOutDate
      }

      if (roomCount !== undefined) {
        localVarQueryParameter['room_count'] = roomCount
      }

      if (numberOfAdults !== undefined) {
        localVarQueryParameter['number_of_adults'] = numberOfAdults
      }

      if (numberOfChildren !== undefined) {
        localVarQueryParameter['number_of_children'] = numberOfChildren
      }

      if (numberOfInfants !== undefined) {
        localVarQueryParameter['number_of_infants'] = numberOfInfants
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (showAllRooms !== undefined) {
        localVarQueryParameter['show_all_rooms'] = showAllRooms
      }

      if (room !== undefined) {
        localVarQueryParameter['room'] = room
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PropertyApi - functional programming interface
 * @export
 */
export const PropertyApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PropertyApiAxiosParamCreator(configuration)
  return {
    /**
     * Get availability status for the specified hotel
     * @param {string} slug Hotel slug
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
     * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHotelAvailabilities(
      slug: string,
      fromDate?: string,
      toDate?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PropertyAvailabilityResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getHotelAvailabilities(
          slug,
          fromDate,
          toDate,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get detailed information for the specified hotel
     * @param {string} slug Hotel slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHotelDetail(
      slug: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GetHotelDetail200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHotelDetail(
        slug,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * List the facility\'s public plans (no room scope). Secret plans are excluded. Each plan carries a single representative price (the cheapest reservable listing) and canReserve is true when any hosting listing is bookable. Used by the plan-first landing page (/:property/plans).
     * @param {string} propertySlug
     * @param {string} [checkInDate]
     * @param {string} [checkOutDate]
     * @param {number} [roomCount]
     * @param {number} [numberOfAdults]
     * @param {number} [numberOfChildren]
     * @param {number} [numberOfInfants]
     * @param {boolean} [showAllPlans] show all plans or can reserve plans
     * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * Default: &#x60;recommendation&#x60;(Order by recommendation)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHotelPlans(
      propertySlug: string,
      checkInDate?: string,
      checkOutDate?: string,
      roomCount?: number,
      numberOfAdults?: number,
      numberOfChildren?: number,
      numberOfInfants?: number,
      showAllPlans?: boolean,
      order?: 'price' | '-price' | 'recommendation',
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<PlanResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHotelPlans(
        propertySlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        showAllPlans,
        order,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get a list of hotels with room types available for reservation
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount Room count
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {boolean} [isHotel] Is hotel or not
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {'order' | '-order' | 'distance' | '-distance' | 'min_price' | '-min_price'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getHotelRooms(
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      offset?: number,
      limit?: number,
      isHotel?: boolean,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      order?:
        | 'order'
        | '-order'
        | 'distance'
        | '-distance'
        | 'min_price'
        | '-min_price',
      showAllRooms?: boolean,
      equipments?: Array<
        | 'no_smoking'
        | 'smoking'
        | 'free_wifi'
        | 'parking'
        | 'spa'
        | 'restaurant'
        | 'pets_allowed'
        | 'family'
      >,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<HotelRoomListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getHotelRooms(
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        offset,
        limit,
        isHotel,
        insideFvillage,
        hotelAreas,
        order,
        showAllRooms,
        equipments,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get plan
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlan(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlanResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPlan(
        propertySlug,
        roomSlug,
        planSlug,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get a plan (indexed by plan slug only) with the rooms it is bookable on
     * @param {string} propertySlug
     * @param {string} planSlug
     * @param {string} [checkInDate]
     * @param {string} [checkOutDate]
     * @param {number} [roomCount]
     * @param {number} [numberOfAdults]
     * @param {number} [numberOfChildren]
     * @param {number} [numberOfInfants]
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
     * @param {string} [room] Room slug to limit display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPlanWithRooms(
      propertySlug: string,
      planSlug: string,
      checkInDate?: string,
      checkOutDate?: string,
      roomCount?: number,
      numberOfAdults?: number,
      numberOfChildren?: number,
      numberOfInfants?: number,
      showAllRooms?: boolean,
      order?: 'min_price' | '-min_price',
      room?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PlanWithRoomsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPlanWithRooms(
          propertySlug,
          planSlug,
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          showAllRooms,
          order,
          room,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get price
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {number} transactionId Transaction ID
     * @param {string} checkInDate Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} checkOutDate Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {number} roomCount Number of rooms
     * @param {number} numberOfAdults Number of adults
     * @param {number} numberOfChildren Number of children
     * @param {number} numberOfInfants Number of infants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPrice(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      transactionId: number,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPrice(
        propertySlug,
        roomSlug,
        planSlug,
        transactionId,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get property
     * @param {string} slug Building slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProperty(
      slug: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PropertyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProperty(
        slug,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get property list
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default today
     * @param {string} [toDate] End date (yyyy-MM-dd) default 4 weeks later
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [withPagination] Pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPropertyAvailabilities(
      offset?: number,
      limit?: number,
      fromDate?: string,
      toDate?: string,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      order?: 'order' | '-order' | 'distance' | '-distance',
      withPagination?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PropertyAvailabilityListResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPropertyAvailabilities(
          offset,
          limit,
          fromDate,
          toDate,
          insideFvillage,
          hotelAreas,
          order,
          withPagination,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get room by slug
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoom(
      propertySlug: string,
      roomSlug: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoomResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoom(
        propertySlug,
        roomSlug,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get availabilities per room category
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
     * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
     * @param {number} [roomId] Room Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoomAvailabilities(
      propertySlug: string,
      roomSlug: string,
      fromDate?: string,
      toDate?: string,
      roomId?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<HotelRoomAvailabilityResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getRoomAvailabilities(
          propertySlug,
          roomSlug,
          fromDate,
          toDate,
          roomId,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * List option
     * @param {string} propertySlug Building slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listOptions(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<OptionResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listOptions(
        propertySlug,
        roomSlug,
        planSlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * List plans
     * @param {string} propertySlug Building slug
     * @param {string} roomSlug Room category slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * default: &#x60;recommendation&#x60;(Order by recommendation)
     * @param {boolean} [showAllPlans] show all plans or can reserve plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listPlans(
      propertySlug: string,
      roomSlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      order?: 'price' | '-price' | 'recommendation',
      showAllPlans?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<PlanResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listPlans(
        propertySlug,
        roomSlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        order,
        showAllPlans,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * List properties
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {boolean} [isHotel] Is hotel or not
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
     * @param {number} [minPrice] Min price
     * @param {number} [maxPrice] Max price
     * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [withPagination] Pagination
     * @param {boolean} [isSecret] Is secret or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listProperties(
      offset?: number,
      limit?: number,
      isHotel?: boolean,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      equipments?: Array<
        | 'no_smoking'
        | 'smoking'
        | 'free_wifi'
        | 'parking'
        | 'spa'
        | 'restaurant'
        | 'pets_allowed'
        | 'family'
      >,
      minPrice?: number,
      maxPrice?: number,
      order?: 'order' | '-order' | 'distance' | '-distance',
      withPagination?: boolean,
      isSecret?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<PropertyListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listProperties(
        offset,
        limit,
        isHotel,
        insideFvillage,
        hotelAreas,
        equipments,
        minPrice,
        maxPrice,
        order,
        withPagination,
        isSecret,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * List rooms
     * @param {string} propertySlug Property slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {string} [room] Room slug to limit display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listRooms(
      propertySlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      order?: 'min_price' | '-min_price',
      showAllRooms?: boolean,
      room?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<RoomResponse>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listRooms(
        propertySlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        order,
        showAllRooms,
        room,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
  }
}

/**
 * PropertyApi - factory interface
 * @export
 */
export const PropertyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = PropertyApiFp(configuration)
  return {
    /**
     * Get availability status for the specified hotel
     * @param {string} slug Hotel slug
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
     * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelAvailabilities(
      slug: string,
      fromDate?: string,
      toDate?: string,
      options?: any
    ): AxiosPromise<PropertyAvailabilityResponse> {
      return localVarFp
        .getHotelAvailabilities(slug, fromDate, toDate, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get detailed information for the specified hotel
     * @param {string} slug Hotel slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelDetail(
      slug: string,
      options?: any
    ): AxiosPromise<GetHotelDetail200Response> {
      return localVarFp
        .getHotelDetail(slug, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * List the facility\'s public plans (no room scope). Secret plans are excluded. Each plan carries a single representative price (the cheapest reservable listing) and canReserve is true when any hosting listing is bookable. Used by the plan-first landing page (/:property/plans).
     * @param {string} propertySlug
     * @param {string} [checkInDate]
     * @param {string} [checkOutDate]
     * @param {number} [roomCount]
     * @param {number} [numberOfAdults]
     * @param {number} [numberOfChildren]
     * @param {number} [numberOfInfants]
     * @param {boolean} [showAllPlans] show all plans or can reserve plans
     * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * Default: &#x60;recommendation&#x60;(Order by recommendation)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelPlans(
      propertySlug: string,
      checkInDate?: string,
      checkOutDate?: string,
      roomCount?: number,
      numberOfAdults?: number,
      numberOfChildren?: number,
      numberOfInfants?: number,
      showAllPlans?: boolean,
      order?: 'price' | '-price' | 'recommendation',
      options?: any
    ): AxiosPromise<Array<PlanResponse>> {
      return localVarFp
        .getHotelPlans(
          propertySlug,
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          showAllPlans,
          order,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a list of hotels with room types available for reservation
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount Room count
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {boolean} [isHotel] Is hotel or not
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {'order' | '-order' | 'distance' | '-distance' | 'min_price' | '-min_price'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getHotelRooms(
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      offset?: number,
      limit?: number,
      isHotel?: boolean,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      order?:
        | 'order'
        | '-order'
        | 'distance'
        | '-distance'
        | 'min_price'
        | '-min_price',
      showAllRooms?: boolean,
      equipments?: Array<
        | 'no_smoking'
        | 'smoking'
        | 'free_wifi'
        | 'parking'
        | 'spa'
        | 'restaurant'
        | 'pets_allowed'
        | 'family'
      >,
      options?: any
    ): AxiosPromise<HotelRoomListResponse> {
      return localVarFp
        .getHotelRooms(
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          offset,
          limit,
          isHotel,
          insideFvillage,
          hotelAreas,
          order,
          showAllRooms,
          equipments,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get plan
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlan(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      options?: any
    ): AxiosPromise<PlanResponse> {
      return localVarFp
        .getPlan(propertySlug, roomSlug, planSlug, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get a plan (indexed by plan slug only) with the rooms it is bookable on
     * @param {string} propertySlug
     * @param {string} planSlug
     * @param {string} [checkInDate]
     * @param {string} [checkOutDate]
     * @param {number} [roomCount]
     * @param {number} [numberOfAdults]
     * @param {number} [numberOfChildren]
     * @param {number} [numberOfInfants]
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
     * @param {string} [room] Room slug to limit display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPlanWithRooms(
      propertySlug: string,
      planSlug: string,
      checkInDate?: string,
      checkOutDate?: string,
      roomCount?: number,
      numberOfAdults?: number,
      numberOfChildren?: number,
      numberOfInfants?: number,
      showAllRooms?: boolean,
      order?: 'min_price' | '-min_price',
      room?: string,
      options?: any
    ): AxiosPromise<PlanWithRoomsResponse> {
      return localVarFp
        .getPlanWithRooms(
          propertySlug,
          planSlug,
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          showAllRooms,
          order,
          room,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get price
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {number} transactionId Transaction ID
     * @param {string} checkInDate Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} checkOutDate Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {number} roomCount Number of rooms
     * @param {number} numberOfAdults Number of adults
     * @param {number} numberOfChildren Number of children
     * @param {number} numberOfInfants Number of infants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrice(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      transactionId: number,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      options?: any
    ): AxiosPromise<PriceResponse> {
      return localVarFp
        .getPrice(
          propertySlug,
          roomSlug,
          planSlug,
          transactionId,
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get property
     * @param {string} slug Building slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProperty(slug: string, options?: any): AxiosPromise<PropertyResponse> {
      return localVarFp
        .getProperty(slug, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get property list
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default today
     * @param {string} [toDate] End date (yyyy-MM-dd) default 4 weeks later
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [withPagination] Pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPropertyAvailabilities(
      offset?: number,
      limit?: number,
      fromDate?: string,
      toDate?: string,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      order?: 'order' | '-order' | 'distance' | '-distance',
      withPagination?: boolean,
      options?: any
    ): AxiosPromise<PropertyAvailabilityListResponse> {
      return localVarFp
        .getPropertyAvailabilities(
          offset,
          limit,
          fromDate,
          toDate,
          insideFvillage,
          hotelAreas,
          order,
          withPagination,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get room by slug
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoom(
      propertySlug: string,
      roomSlug: string,
      options?: any
    ): AxiosPromise<RoomResponse> {
      return localVarFp
        .getRoom(propertySlug, roomSlug, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get availabilities per room category
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category
     * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
     * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
     * @param {number} [roomId] Room Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoomAvailabilities(
      propertySlug: string,
      roomSlug: string,
      fromDate?: string,
      toDate?: string,
      roomId?: number,
      options?: any
    ): AxiosPromise<HotelRoomAvailabilityResponse> {
      return localVarFp
        .getRoomAvailabilities(
          propertySlug,
          roomSlug,
          fromDate,
          toDate,
          roomId,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List option
     * @param {string} propertySlug Building slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listOptions(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      options?: any
    ): AxiosPromise<Array<OptionResponse>> {
      return localVarFp
        .listOptions(
          propertySlug,
          roomSlug,
          planSlug,
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List plans
     * @param {string} propertySlug Building slug
     * @param {string} roomSlug Room category slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * default: &#x60;recommendation&#x60;(Order by recommendation)
     * @param {boolean} [showAllPlans] show all plans or can reserve plans
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listPlans(
      propertySlug: string,
      roomSlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      order?: 'price' | '-price' | 'recommendation',
      showAllPlans?: boolean,
      options?: any
    ): AxiosPromise<Array<PlanResponse>> {
      return localVarFp
        .listPlans(
          propertySlug,
          roomSlug,
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          order,
          showAllPlans,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List properties
     * @param {number} [offset] Start  * Default: 0
     * @param {number} [limit] Limit  * Default: 100  * Max: 1000
     * @param {boolean} [isHotel] Is hotel or not
     * @param {boolean} [insideFvillage] Inside fvillage or not
     * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
     * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
     * @param {number} [minPrice] Min price
     * @param {number} [maxPrice] Max price
     * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
     * @param {boolean} [withPagination] Pagination
     * @param {boolean} [isSecret] Is secret or not
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProperties(
      offset?: number,
      limit?: number,
      isHotel?: boolean,
      insideFvillage?: boolean,
      hotelAreas?: Array<
        | 'fvillage'
        | 'kitahiroshima'
        | 'sapporo'
        | 'chitose'
        | 'shinsapporo'
        | 'others'
      >,
      equipments?: Array<
        | 'no_smoking'
        | 'smoking'
        | 'free_wifi'
        | 'parking'
        | 'spa'
        | 'restaurant'
        | 'pets_allowed'
        | 'family'
      >,
      minPrice?: number,
      maxPrice?: number,
      order?: 'order' | '-order' | 'distance' | '-distance',
      withPagination?: boolean,
      isSecret?: boolean,
      options?: any
    ): AxiosPromise<PropertyListResponse> {
      return localVarFp
        .listProperties(
          offset,
          limit,
          isHotel,
          insideFvillage,
          hotelAreas,
          equipments,
          minPrice,
          maxPrice,
          order,
          withPagination,
          isSecret,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * List rooms
     * @param {string} propertySlug Property slug
     * @param {string} checkInDate Check in date
     * @param {string} checkOutDate Check out date
     * @param {number} roomCount
     * @param {number} numberOfAdults
     * @param {number} numberOfChildren
     * @param {number} numberOfInfants
     * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
     * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
     * @param {string} [room] Room slug to limit display
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listRooms(
      propertySlug: string,
      checkInDate: string,
      checkOutDate: string,
      roomCount: number,
      numberOfAdults: number,
      numberOfChildren: number,
      numberOfInfants: number,
      order?: 'min_price' | '-min_price',
      showAllRooms?: boolean,
      room?: string,
      options?: any
    ): AxiosPromise<Array<RoomResponse>> {
      return localVarFp
        .listRooms(
          propertySlug,
          checkInDate,
          checkOutDate,
          roomCount,
          numberOfAdults,
          numberOfChildren,
          numberOfInfants,
          order,
          showAllRooms,
          room,
          options
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PropertyApi - interface
 * @export
 * @interface PropertyApi
 */
export interface PropertyApiInterface {
  /**
   * Get availability status for the specified hotel
   * @param {string} slug Hotel slug
   * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
   * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getHotelAvailabilities(
    slug: string,
    fromDate?: string,
    toDate?: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<PropertyAvailabilityResponse>

  /**
   * Get detailed information for the specified hotel
   * @param {string} slug Hotel slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getHotelDetail(
    slug: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<GetHotelDetail200Response>

  /**
   * List the facility\'s public plans (no room scope). Secret plans are excluded. Each plan carries a single representative price (the cheapest reservable listing) and canReserve is true when any hosting listing is bookable. Used by the plan-first landing page (/:property/plans).
   * @param {string} propertySlug
   * @param {string} [checkInDate]
   * @param {string} [checkOutDate]
   * @param {number} [roomCount]
   * @param {number} [numberOfAdults]
   * @param {number} [numberOfChildren]
   * @param {number} [numberOfInfants]
   * @param {boolean} [showAllPlans] show all plans or can reserve plans
   * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * Default: &#x60;recommendation&#x60;(Order by recommendation)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getHotelPlans(
    propertySlug: string,
    checkInDate?: string,
    checkOutDate?: string,
    roomCount?: number,
    numberOfAdults?: number,
    numberOfChildren?: number,
    numberOfInfants?: number,
    showAllPlans?: boolean,
    order?: 'price' | '-price' | 'recommendation',
    options?: AxiosRequestConfig
  ): AxiosPromise<Array<PlanResponse>>

  /**
   * Get a list of hotels with room types available for reservation
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount Room count
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {number} [offset] Start  * Default: 0
   * @param {number} [limit] Limit  * Default: 100  * Max: 1000
   * @param {boolean} [isHotel] Is hotel or not
   * @param {boolean} [insideFvillage] Inside fvillage or not
   * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
   * @param {'order' | '-order' | 'distance' | '-distance' | 'min_price' | '-min_price'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
   * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
   * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getHotelRooms(
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    offset?: number,
    limit?: number,
    isHotel?: boolean,
    insideFvillage?: boolean,
    hotelAreas?: Array<
      | 'fvillage'
      | 'kitahiroshima'
      | 'sapporo'
      | 'chitose'
      | 'shinsapporo'
      | 'others'
    >,
    order?:
      | 'order'
      | '-order'
      | 'distance'
      | '-distance'
      | 'min_price'
      | '-min_price',
    showAllRooms?: boolean,
    equipments?: Array<
      | 'no_smoking'
      | 'smoking'
      | 'free_wifi'
      | 'parking'
      | 'spa'
      | 'restaurant'
      | 'pets_allowed'
      | 'family'
    >,
    options?: AxiosRequestConfig
  ): AxiosPromise<HotelRoomListResponse>

  /**
   * Get plan
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getPlan(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<PlanResponse>

  /**
   * Get a plan (indexed by plan slug only) with the rooms it is bookable on
   * @param {string} propertySlug
   * @param {string} planSlug
   * @param {string} [checkInDate]
   * @param {string} [checkOutDate]
   * @param {number} [roomCount]
   * @param {number} [numberOfAdults]
   * @param {number} [numberOfChildren]
   * @param {number} [numberOfInfants]
   * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
   * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
   * @param {string} [room] Room slug to limit display
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getPlanWithRooms(
    propertySlug: string,
    planSlug: string,
    checkInDate?: string,
    checkOutDate?: string,
    roomCount?: number,
    numberOfAdults?: number,
    numberOfChildren?: number,
    numberOfInfants?: number,
    showAllRooms?: boolean,
    order?: 'min_price' | '-min_price',
    room?: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<PlanWithRoomsResponse>

  /**
   * Get price
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {number} transactionId Transaction ID
   * @param {string} checkInDate Check-in date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} checkOutDate Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {number} roomCount Number of rooms
   * @param {number} numberOfAdults Number of adults
   * @param {number} numberOfChildren Number of children
   * @param {number} numberOfInfants Number of infants
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getPrice(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    transactionId: number,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<PriceResponse>

  /**
   * Get property
   * @param {string} slug Building slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getProperty(
    slug: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<PropertyResponse>

  /**
   * Get property list
   * @param {number} [offset] Start  * Default: 0
   * @param {number} [limit] Limit  * Default: 100  * Max: 1000
   * @param {string} [fromDate] Start date (yyyy-MM-dd) default today
   * @param {string} [toDate] End date (yyyy-MM-dd) default 4 weeks later
   * @param {boolean} [insideFvillage] Inside fvillage or not
   * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
   * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
   * @param {boolean} [withPagination] Pagination
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getPropertyAvailabilities(
    offset?: number,
    limit?: number,
    fromDate?: string,
    toDate?: string,
    insideFvillage?: boolean,
    hotelAreas?: Array<
      | 'fvillage'
      | 'kitahiroshima'
      | 'sapporo'
      | 'chitose'
      | 'shinsapporo'
      | 'others'
    >,
    order?: 'order' | '-order' | 'distance' | '-distance',
    withPagination?: boolean,
    options?: AxiosRequestConfig
  ): AxiosPromise<PropertyAvailabilityListResponse>

  /**
   * Get room by slug
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getRoom(
    propertySlug: string,
    roomSlug: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<RoomResponse>

  /**
   * Get availabilities per room category
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category
   * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
   * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
   * @param {number} [roomId] Room Id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  getRoomAvailabilities(
    propertySlug: string,
    roomSlug: string,
    fromDate?: string,
    toDate?: string,
    roomId?: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<HotelRoomAvailabilityResponse>

  /**
   * List option
   * @param {string} propertySlug Building slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  listOptions(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<Array<OptionResponse>>

  /**
   * List plans
   * @param {string} propertySlug Building slug
   * @param {string} roomSlug Room category slug
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * default: &#x60;recommendation&#x60;(Order by recommendation)
   * @param {boolean} [showAllPlans] show all plans or can reserve plans
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  listPlans(
    propertySlug: string,
    roomSlug: string,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    order?: 'price' | '-price' | 'recommendation',
    showAllPlans?: boolean,
    options?: AxiosRequestConfig
  ): AxiosPromise<Array<PlanResponse>>

  /**
   * List properties
   * @param {number} [offset] Start  * Default: 0
   * @param {number} [limit] Limit  * Default: 100  * Max: 1000
   * @param {boolean} [isHotel] Is hotel or not
   * @param {boolean} [insideFvillage] Inside fvillage or not
   * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
   * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
   * @param {number} [minPrice] Min price
   * @param {number} [maxPrice] Max price
   * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
   * @param {boolean} [withPagination] Pagination
   * @param {boolean} [isSecret] Is secret or not
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  listProperties(
    offset?: number,
    limit?: number,
    isHotel?: boolean,
    insideFvillage?: boolean,
    hotelAreas?: Array<
      | 'fvillage'
      | 'kitahiroshima'
      | 'sapporo'
      | 'chitose'
      | 'shinsapporo'
      | 'others'
    >,
    equipments?: Array<
      | 'no_smoking'
      | 'smoking'
      | 'free_wifi'
      | 'parking'
      | 'spa'
      | 'restaurant'
      | 'pets_allowed'
      | 'family'
    >,
    minPrice?: number,
    maxPrice?: number,
    order?: 'order' | '-order' | 'distance' | '-distance',
    withPagination?: boolean,
    isSecret?: boolean,
    options?: AxiosRequestConfig
  ): AxiosPromise<PropertyListResponse>

  /**
   * List rooms
   * @param {string} propertySlug Property slug
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
   * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
   * @param {string} [room] Room slug to limit display
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApiInterface
   */
  listRooms(
    propertySlug: string,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    order?: 'min_price' | '-min_price',
    showAllRooms?: boolean,
    room?: string,
    options?: AxiosRequestConfig
  ): AxiosPromise<Array<RoomResponse>>
}

/**
 * PropertyApi - object-oriented interface
 * @export
 * @class PropertyApi
 * @extends {BaseAPI}
 */
export class PropertyApi extends BaseAPI implements PropertyApiInterface {
  /**
   * Get availability status for the specified hotel
   * @param {string} slug Hotel slug
   * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
   * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getHotelAvailabilities(
    slug: string,
    fromDate?: string,
    toDate?: string,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getHotelAvailabilities(slug, fromDate, toDate, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get detailed information for the specified hotel
   * @param {string} slug Hotel slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getHotelDetail(slug: string, options?: AxiosRequestConfig) {
    return PropertyApiFp(this.configuration)
      .getHotelDetail(slug, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List the facility\'s public plans (no room scope). Secret plans are excluded. Each plan carries a single representative price (the cheapest reservable listing) and canReserve is true when any hosting listing is bookable. Used by the plan-first landing page (/:property/plans).
   * @param {string} propertySlug
   * @param {string} [checkInDate]
   * @param {string} [checkOutDate]
   * @param {number} [roomCount]
   * @param {number} [numberOfAdults]
   * @param {number} [numberOfChildren]
   * @param {number} [numberOfInfants]
   * @param {boolean} [showAllPlans] show all plans or can reserve plans
   * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * Default: &#x60;recommendation&#x60;(Order by recommendation)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getHotelPlans(
    propertySlug: string,
    checkInDate?: string,
    checkOutDate?: string,
    roomCount?: number,
    numberOfAdults?: number,
    numberOfChildren?: number,
    numberOfInfants?: number,
    showAllPlans?: boolean,
    order?: 'price' | '-price' | 'recommendation',
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getHotelPlans(
        propertySlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        showAllPlans,
        order,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a list of hotels with room types available for reservation
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount Room count
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {number} [offset] Start  * Default: 0
   * @param {number} [limit] Limit  * Default: 100  * Max: 1000
   * @param {boolean} [isHotel] Is hotel or not
   * @param {boolean} [insideFvillage] Inside fvillage or not
   * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
   * @param {'order' | '-order' | 'distance' | '-distance' | 'min_price' | '-min_price'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
   * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
   * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getHotelRooms(
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    offset?: number,
    limit?: number,
    isHotel?: boolean,
    insideFvillage?: boolean,
    hotelAreas?: Array<
      | 'fvillage'
      | 'kitahiroshima'
      | 'sapporo'
      | 'chitose'
      | 'shinsapporo'
      | 'others'
    >,
    order?:
      | 'order'
      | '-order'
      | 'distance'
      | '-distance'
      | 'min_price'
      | '-min_price',
    showAllRooms?: boolean,
    equipments?: Array<
      | 'no_smoking'
      | 'smoking'
      | 'free_wifi'
      | 'parking'
      | 'spa'
      | 'restaurant'
      | 'pets_allowed'
      | 'family'
    >,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getHotelRooms(
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        offset,
        limit,
        isHotel,
        insideFvillage,
        hotelAreas,
        order,
        showAllRooms,
        equipments,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get plan
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getPlan(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getPlan(propertySlug, roomSlug, planSlug, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get a plan (indexed by plan slug only) with the rooms it is bookable on
   * @param {string} propertySlug
   * @param {string} planSlug
   * @param {string} [checkInDate]
   * @param {string} [checkOutDate]
   * @param {number} [roomCount]
   * @param {number} [numberOfAdults]
   * @param {number} [numberOfChildren]
   * @param {number} [numberOfInfants]
   * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
   * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
   * @param {string} [room] Room slug to limit display
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getPlanWithRooms(
    propertySlug: string,
    planSlug: string,
    checkInDate?: string,
    checkOutDate?: string,
    roomCount?: number,
    numberOfAdults?: number,
    numberOfChildren?: number,
    numberOfInfants?: number,
    showAllRooms?: boolean,
    order?: 'min_price' | '-min_price',
    room?: string,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getPlanWithRooms(
        propertySlug,
        planSlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        showAllRooms,
        order,
        room,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get price
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {number} transactionId Transaction ID
   * @param {string} checkInDate Check-in date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} checkOutDate Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {number} roomCount Number of rooms
   * @param {number} numberOfAdults Number of adults
   * @param {number} numberOfChildren Number of children
   * @param {number} numberOfInfants Number of infants
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getPrice(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    transactionId: number,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getPrice(
        propertySlug,
        roomSlug,
        planSlug,
        transactionId,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get property
   * @param {string} slug Building slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getProperty(slug: string, options?: AxiosRequestConfig) {
    return PropertyApiFp(this.configuration)
      .getProperty(slug, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get property list
   * @param {number} [offset] Start  * Default: 0
   * @param {number} [limit] Limit  * Default: 100  * Max: 1000
   * @param {string} [fromDate] Start date (yyyy-MM-dd) default today
   * @param {string} [toDate] End date (yyyy-MM-dd) default 4 weeks later
   * @param {boolean} [insideFvillage] Inside fvillage or not
   * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
   * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
   * @param {boolean} [withPagination] Pagination
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getPropertyAvailabilities(
    offset?: number,
    limit?: number,
    fromDate?: string,
    toDate?: string,
    insideFvillage?: boolean,
    hotelAreas?: Array<
      | 'fvillage'
      | 'kitahiroshima'
      | 'sapporo'
      | 'chitose'
      | 'shinsapporo'
      | 'others'
    >,
    order?: 'order' | '-order' | 'distance' | '-distance',
    withPagination?: boolean,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getPropertyAvailabilities(
        offset,
        limit,
        fromDate,
        toDate,
        insideFvillage,
        hotelAreas,
        order,
        withPagination,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get room by slug
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getRoom(
    propertySlug: string,
    roomSlug: string,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getRoom(propertySlug, roomSlug, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get availabilities per room category
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category
   * @param {string} [fromDate] Start date (yyyy-MM-dd) default is tomorrow
   * @param {string} [toDate] End date (yyyy-MM-dd) default is 4 weeks later
   * @param {number} [roomId] Room Id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public getRoomAvailabilities(
    propertySlug: string,
    roomSlug: string,
    fromDate?: string,
    toDate?: string,
    roomId?: number,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .getRoomAvailabilities(
        propertySlug,
        roomSlug,
        fromDate,
        toDate,
        roomId,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List option
   * @param {string} propertySlug Building slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public listOptions(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .listOptions(
        propertySlug,
        roomSlug,
        planSlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List plans
   * @param {string} propertySlug Building slug
   * @param {string} roomSlug Room category slug
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {'price' | '-price' | 'recommendation'} [order] Sort order   * default: &#x60;recommendation&#x60;(Order by recommendation)
   * @param {boolean} [showAllPlans] show all plans or can reserve plans
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public listPlans(
    propertySlug: string,
    roomSlug: string,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    order?: 'price' | '-price' | 'recommendation',
    showAllPlans?: boolean,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .listPlans(
        propertySlug,
        roomSlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        order,
        showAllPlans,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List properties
   * @param {number} [offset] Start  * Default: 0
   * @param {number} [limit] Limit  * Default: 100  * Max: 1000
   * @param {boolean} [isHotel] Is hotel or not
   * @param {boolean} [insideFvillage] Inside fvillage or not
   * @param {Array<'fvillage' | 'kitahiroshima' | 'sapporo' | 'chitose' | 'shinsapporo' | 'others'>} [hotelAreas] Hotel areas
   * @param {Array<'no_smoking' | 'smoking' | 'free_wifi' | 'parking' | 'spa' | 'restaurant' | 'pets_allowed' | 'family'>} [equipments] Equipments
   * @param {number} [minPrice] Min price
   * @param {number} [maxPrice] Max price
   * @param {'order' | '-order' | 'distance' | '-distance'} [order] Order   * Default: &#x60;order&#x60;（recommended order）
   * @param {boolean} [withPagination] Pagination
   * @param {boolean} [isSecret] Is secret or not
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public listProperties(
    offset?: number,
    limit?: number,
    isHotel?: boolean,
    insideFvillage?: boolean,
    hotelAreas?: Array<
      | 'fvillage'
      | 'kitahiroshima'
      | 'sapporo'
      | 'chitose'
      | 'shinsapporo'
      | 'others'
    >,
    equipments?: Array<
      | 'no_smoking'
      | 'smoking'
      | 'free_wifi'
      | 'parking'
      | 'spa'
      | 'restaurant'
      | 'pets_allowed'
      | 'family'
    >,
    minPrice?: number,
    maxPrice?: number,
    order?: 'order' | '-order' | 'distance' | '-distance',
    withPagination?: boolean,
    isSecret?: boolean,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .listProperties(
        offset,
        limit,
        isHotel,
        insideFvillage,
        hotelAreas,
        equipments,
        minPrice,
        maxPrice,
        order,
        withPagination,
        isSecret,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * List rooms
   * @param {string} propertySlug Property slug
   * @param {string} checkInDate Check in date
   * @param {string} checkOutDate Check out date
   * @param {number} roomCount
   * @param {number} numberOfAdults
   * @param {number} numberOfChildren
   * @param {number} numberOfInfants
   * @param {'min_price' | '-min_price'} [order] Sort order   * Default: &#x60;min_price&#x60;(Order by low price)
   * @param {boolean} [showAllRooms] show all rooms or can reserve rooms
   * @param {string} [room] Room slug to limit display
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertyApi
   */
  public listRooms(
    propertySlug: string,
    checkInDate: string,
    checkOutDate: string,
    roomCount: number,
    numberOfAdults: number,
    numberOfChildren: number,
    numberOfInfants: number,
    order?: 'min_price' | '-min_price',
    showAllRooms?: boolean,
    room?: string,
    options?: AxiosRequestConfig
  ) {
    return PropertyApiFp(this.configuration)
      .listRooms(
        propertySlug,
        checkInDate,
        checkOutDate,
        roomCount,
        numberOfAdults,
        numberOfChildren,
        numberOfInfants,
        order,
        showAllRooms,
        room,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * ReservationApi - axios parameter creator
 * @export
 */
export const ReservationApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Get cancellation price by id
     * @param {number} id Reservation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelConfirmation: async (
      id: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cancelConfirmation', 'id', id)
      const localVarPath = `/reservations/{id}/confirm-cancellation`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Cancel reservation by given id
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelReservation: async (
      id: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('cancelReservation', 'id', id)
      const localVarPath = `/reservations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Create reservation
     * @param {CreateReservationRequest} [createReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createReservation: async (
      createReservationRequest?: CreateReservationRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/reservations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createReservationRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get reservation by id
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservation: async (
      id: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getReservation', 'id', id)
      const localVarPath = `/reservations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get reservation price
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservationPrice: async (
      id: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getReservationPrice', 'id', id)
      const localVarPath = `/reservations/{id}/price`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Issue a signed PDF URL valid for 12 hours, consuming one receipt view (default limit of five). Returns 403 when the receipt view limit is exhausted.
     * @param {number} id
     * @param {number} receiptId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservationReceipt: async (
      id: number,
      receiptId: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getReservationReceipt', 'id', id)
      // verify required parameter 'receiptId' is not null or undefined
      assertParamExists('getReservationReceipt', 'receiptId', receiptId)
      const localVarPath = `/reservations/{id}/receipts/{receiptId}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'receiptId'}}`, encodeURIComponent(String(receiptId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get reservation list
     * @param {number} [offset] Offset  * Default: 0
     * @param {number} [limit] Limit  * Default: 50  * Max: 1000
     * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
     * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {boolean} [isCancelled] Is canceled
     * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
     * @param {boolean} [isHotel]
     * @param {boolean} [isSpa]
     * @param {boolean} [isActivity]
     * @param {number} [transaction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservations: async (
      offset?: number,
      limit?: number,
      checkInDateFrom?: string,
      checkInDateTo?: string,
      checkOutDateFrom?: string,
      checkOutDateTo?: string,
      isCancelled?: boolean,
      order?:
        | 'created_at'
        | '-created_at'
        | 'check_in_date'
        | '-check_in_date'
        | 'check_out_date'
        | '-check_out_date',
      isHotel?: boolean,
      isSpa?: boolean,
      isActivity?: boolean,
      transaction?: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/reservations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (checkInDateFrom !== undefined) {
        localVarQueryParameter['check_in_date_from'] =
          (checkInDateFrom as any) instanceof Date
            ? (checkInDateFrom as any).toISOString().substr(0, 10)
            : checkInDateFrom
      }

      if (checkInDateTo !== undefined) {
        localVarQueryParameter['check_in_date_to'] =
          (checkInDateTo as any) instanceof Date
            ? (checkInDateTo as any).toISOString().substr(0, 10)
            : checkInDateTo
      }

      if (checkOutDateFrom !== undefined) {
        localVarQueryParameter['check_out_date_from'] =
          (checkOutDateFrom as any) instanceof Date
            ? (checkOutDateFrom as any).toISOString().substr(0, 10)
            : checkOutDateFrom
      }

      if (checkOutDateTo !== undefined) {
        localVarQueryParameter['check_out_date_to'] =
          (checkOutDateTo as any) instanceof Date
            ? (checkOutDateTo as any).toISOString().substr(0, 10)
            : checkOutDateTo
      }

      if (isCancelled !== undefined) {
        localVarQueryParameter['is_cancelled'] = isCancelled
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (isHotel !== undefined) {
        localVarQueryParameter['is_hotel'] = isHotel
      }

      if (isSpa !== undefined) {
        localVarQueryParameter['is_spa'] = isSpa
      }

      if (isActivity !== undefined) {
        localVarQueryParameter['is_activity'] = isActivity
      }

      if (transaction !== undefined) {
        localVarQueryParameter['transaction'] = transaction
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get recent reservation list
     * @param {number} [offset] Offset  * Default: 0
     * @param {number} [limit] Limit  * Default: 50  * Max: 1000
     * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
     * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {boolean} [isCancelled] Is canceled
     * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
     * @param {boolean} [isHotel]
     * @param {boolean} [isSpa]
     * @param {boolean} [isActivity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservationsRecent: async (
      offset?: number,
      limit?: number,
      checkInDateFrom?: string,
      checkInDateTo?: string,
      checkOutDateFrom?: string,
      checkOutDateTo?: string,
      isCancelled?: boolean,
      order?:
        | 'created_at'
        | '-created_at'
        | 'check_in_date'
        | '-check_in_date'
        | 'check_out_date'
        | '-check_out_date',
      isHotel?: boolean,
      isSpa?: boolean,
      isActivity?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/reservations/recent`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (offset !== undefined) {
        localVarQueryParameter['offset'] = offset
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (checkInDateFrom !== undefined) {
        localVarQueryParameter['check_in_date_from'] =
          (checkInDateFrom as any) instanceof Date
            ? (checkInDateFrom as any).toISOString().substr(0, 10)
            : checkInDateFrom
      }

      if (checkInDateTo !== undefined) {
        localVarQueryParameter['check_in_date_to'] =
          (checkInDateTo as any) instanceof Date
            ? (checkInDateTo as any).toISOString().substr(0, 10)
            : checkInDateTo
      }

      if (checkOutDateFrom !== undefined) {
        localVarQueryParameter['check_out_date_from'] =
          (checkOutDateFrom as any) instanceof Date
            ? (checkOutDateFrom as any).toISOString().substr(0, 10)
            : checkOutDateFrom
      }

      if (checkOutDateTo !== undefined) {
        localVarQueryParameter['check_out_date_to'] =
          (checkOutDateTo as any) instanceof Date
            ? (checkOutDateTo as any).toISOString().substr(0, 10)
            : checkOutDateTo
      }

      if (isCancelled !== undefined) {
        localVarQueryParameter['is_cancelled'] = isCancelled
      }

      if (order !== undefined) {
        localVarQueryParameter['order'] = order
      }

      if (isHotel !== undefined) {
        localVarQueryParameter['is_hotel'] = isHotel
      }

      if (isSpa !== undefined) {
        localVarQueryParameter['is_spa'] = isSpa
      }

      if (isActivity !== undefined) {
        localVarQueryParameter['is_activity'] = isActivity
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Issue a receipt for the booking owner after payment is recorded
     * @param {number} id
     * @param {IssueReceiptRequest} issueReceiptRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueReservationReceipt: async (
      id: number,
      issueReceiptRequest: IssueReceiptRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('issueReservationReceipt', 'id', id)
      // verify required parameter 'issueReceiptRequest' is not null or undefined
      assertParamExists(
        'issueReservationReceipt',
        'issueReceiptRequest',
        issueReceiptRequest
      )
      const localVarPath = `/reservations/{id}/receipts`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        issueReceiptRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ReservationApi - functional programming interface
 * @export
 */
export const ReservationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ReservationApiAxiosParamCreator(configuration)
  return {
    /**
     * Get cancellation price by id
     * @param {number} id Reservation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelConfirmation(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CancelConfirmation>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cancelConfirmation(id, options)
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Cancel reservation by given id
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelReservation(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.cancelReservation(id, options)
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Create reservation
     * @param {CreateReservationRequest} [createReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createReservation(
      createReservationRequest?: CreateReservationRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ReservationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createReservation(
          createReservationRequest,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get reservation by id
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReservation(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ReservationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReservation(
        id,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get reservation price
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReservationPrice(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getReservationPrice(id, options)
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Issue a signed PDF URL valid for 12 hours, consuming one receipt view (default limit of five). Returns 403 when the receipt view limit is exhausted.
     * @param {number} id
     * @param {number} receiptId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReservationReceipt(
      id: number,
      receiptId: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ReceiptDownloadResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getReservationReceipt(
          id,
          receiptId,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get reservation list
     * @param {number} [offset] Offset  * Default: 0
     * @param {number} [limit] Limit  * Default: 50  * Max: 1000
     * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
     * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {boolean} [isCancelled] Is canceled
     * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
     * @param {boolean} [isHotel]
     * @param {boolean} [isSpa]
     * @param {boolean} [isActivity]
     * @param {number} [transaction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReservations(
      offset?: number,
      limit?: number,
      checkInDateFrom?: string,
      checkInDateTo?: string,
      checkOutDateFrom?: string,
      checkOutDateTo?: string,
      isCancelled?: boolean,
      order?:
        | 'created_at'
        | '-created_at'
        | 'check_in_date'
        | '-check_in_date'
        | 'check_out_date'
        | '-check_out_date',
      isHotel?: boolean,
      isSpa?: boolean,
      isActivity?: boolean,
      transaction?: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ReservationsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getReservations(
        offset,
        limit,
        checkInDateFrom,
        checkInDateTo,
        checkOutDateFrom,
        checkOutDateTo,
        isCancelled,
        order,
        isHotel,
        isSpa,
        isActivity,
        transaction,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get recent reservation list
     * @param {number} [offset] Offset  * Default: 0
     * @param {number} [limit] Limit  * Default: 50  * Max: 1000
     * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
     * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {boolean} [isCancelled] Is canceled
     * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
     * @param {boolean} [isHotel]
     * @param {boolean} [isSpa]
     * @param {boolean} [isActivity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getReservationsRecent(
      offset?: number,
      limit?: number,
      checkInDateFrom?: string,
      checkInDateTo?: string,
      checkOutDateFrom?: string,
      checkOutDateTo?: string,
      isCancelled?: boolean,
      order?:
        | 'created_at'
        | '-created_at'
        | 'check_in_date'
        | '-check_in_date'
        | 'check_out_date'
        | '-check_out_date',
      isHotel?: boolean,
      isSpa?: boolean,
      isActivity?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ReservationsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getReservationsRecent(
          offset,
          limit,
          checkInDateFrom,
          checkInDateTo,
          checkOutDateFrom,
          checkOutDateTo,
          isCancelled,
          order,
          isHotel,
          isSpa,
          isActivity,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Issue a receipt for the booking owner after payment is recorded
     * @param {number} id
     * @param {IssueReceiptRequest} issueReceiptRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issueReservationReceipt(
      id: number,
      issueReceiptRequest: IssueReceiptRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IssueReceiptResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.issueReservationReceipt(
          id,
          issueReceiptRequest,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
  }
}

/**
 * ReservationApi - factory interface
 * @export
 */
export const ReservationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ReservationApiFp(configuration)
  return {
    /**
     * Get cancellation price by id
     * @param {number} id Reservation ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelConfirmation(
      id: number,
      options?: any
    ): AxiosPromise<CancelConfirmation> {
      return localVarFp
        .cancelConfirmation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Cancel reservation by given id
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelReservation(id: number, options?: any): AxiosPromise<object> {
      return localVarFp
        .cancelReservation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Create reservation
     * @param {CreateReservationRequest} [createReservationRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createReservation(
      createReservationRequest?: CreateReservationRequest,
      options?: any
    ): AxiosPromise<ReservationResponse> {
      return localVarFp
        .createReservation(createReservationRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get reservation by id
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservation(
      id: number,
      options?: any
    ): AxiosPromise<ReservationResponse> {
      return localVarFp
        .getReservation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get reservation price
     * @param {number} id Reservation id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservationPrice(
      id: number,
      options?: any
    ): AxiosPromise<PriceResponse> {
      return localVarFp
        .getReservationPrice(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Issue a signed PDF URL valid for 12 hours, consuming one receipt view (default limit of five). Returns 403 when the receipt view limit is exhausted.
     * @param {number} id
     * @param {number} receiptId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservationReceipt(
      id: number,
      receiptId: number,
      options?: any
    ): AxiosPromise<ReceiptDownloadResponse> {
      return localVarFp
        .getReservationReceipt(id, receiptId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get reservation list
     * @param {number} [offset] Offset  * Default: 0
     * @param {number} [limit] Limit  * Default: 50  * Max: 1000
     * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
     * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {boolean} [isCancelled] Is canceled
     * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
     * @param {boolean} [isHotel]
     * @param {boolean} [isSpa]
     * @param {boolean} [isActivity]
     * @param {number} [transaction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservations(
      offset?: number,
      limit?: number,
      checkInDateFrom?: string,
      checkInDateTo?: string,
      checkOutDateFrom?: string,
      checkOutDateTo?: string,
      isCancelled?: boolean,
      order?:
        | 'created_at'
        | '-created_at'
        | 'check_in_date'
        | '-check_in_date'
        | 'check_out_date'
        | '-check_out_date',
      isHotel?: boolean,
      isSpa?: boolean,
      isActivity?: boolean,
      transaction?: number,
      options?: any
    ): AxiosPromise<ReservationsResponse> {
      return localVarFp
        .getReservations(
          offset,
          limit,
          checkInDateFrom,
          checkInDateTo,
          checkOutDateFrom,
          checkOutDateTo,
          isCancelled,
          order,
          isHotel,
          isSpa,
          isActivity,
          transaction,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Get recent reservation list
     * @param {number} [offset] Offset  * Default: 0
     * @param {number} [limit] Limit  * Default: 50  * Max: 1000
     * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
     * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
     * @param {boolean} [isCancelled] Is canceled
     * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
     * @param {boolean} [isHotel]
     * @param {boolean} [isSpa]
     * @param {boolean} [isActivity]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getReservationsRecent(
      offset?: number,
      limit?: number,
      checkInDateFrom?: string,
      checkInDateTo?: string,
      checkOutDateFrom?: string,
      checkOutDateTo?: string,
      isCancelled?: boolean,
      order?:
        | 'created_at'
        | '-created_at'
        | 'check_in_date'
        | '-check_in_date'
        | 'check_out_date'
        | '-check_out_date',
      isHotel?: boolean,
      isSpa?: boolean,
      isActivity?: boolean,
      options?: any
    ): AxiosPromise<ReservationsResponse> {
      return localVarFp
        .getReservationsRecent(
          offset,
          limit,
          checkInDateFrom,
          checkInDateTo,
          checkOutDateFrom,
          checkOutDateTo,
          isCancelled,
          order,
          isHotel,
          isSpa,
          isActivity,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Issue a receipt for the booking owner after payment is recorded
     * @param {number} id
     * @param {IssueReceiptRequest} issueReceiptRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issueReservationReceipt(
      id: number,
      issueReceiptRequest: IssueReceiptRequest,
      options?: any
    ): AxiosPromise<IssueReceiptResponse> {
      return localVarFp
        .issueReservationReceipt(id, issueReceiptRequest, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * ReservationApi - interface
 * @export
 * @interface ReservationApi
 */
export interface ReservationApiInterface {
  /**
   * Get cancellation price by id
   * @param {number} id Reservation ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  cancelConfirmation(
    id: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<CancelConfirmation>

  /**
   * Cancel reservation by given id
   * @param {number} id Reservation id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  cancelReservation(
    id: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<object>

  /**
   * Create reservation
   * @param {CreateReservationRequest} [createReservationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  createReservation(
    createReservationRequest?: CreateReservationRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<ReservationResponse>

  /**
   * Get reservation by id
   * @param {number} id Reservation id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  getReservation(
    id: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<ReservationResponse>

  /**
   * Get reservation price
   * @param {number} id Reservation id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  getReservationPrice(
    id: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<PriceResponse>

  /**
   * Issue a signed PDF URL valid for 12 hours, consuming one receipt view (default limit of five). Returns 403 when the receipt view limit is exhausted.
   * @param {number} id
   * @param {number} receiptId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  getReservationReceipt(
    id: number,
    receiptId: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<ReceiptDownloadResponse>

  /**
   * Get reservation list
   * @param {number} [offset] Offset  * Default: 0
   * @param {number} [limit] Limit  * Default: 50  * Max: 1000
   * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
   * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {boolean} [isCancelled] Is canceled
   * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
   * @param {boolean} [isHotel]
   * @param {boolean} [isSpa]
   * @param {boolean} [isActivity]
   * @param {number} [transaction]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  getReservations(
    offset?: number,
    limit?: number,
    checkInDateFrom?: string,
    checkInDateTo?: string,
    checkOutDateFrom?: string,
    checkOutDateTo?: string,
    isCancelled?: boolean,
    order?:
      | 'created_at'
      | '-created_at'
      | 'check_in_date'
      | '-check_in_date'
      | 'check_out_date'
      | '-check_out_date',
    isHotel?: boolean,
    isSpa?: boolean,
    isActivity?: boolean,
    transaction?: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<ReservationsResponse>

  /**
   * Get recent reservation list
   * @param {number} [offset] Offset  * Default: 0
   * @param {number} [limit] Limit  * Default: 50  * Max: 1000
   * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
   * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {boolean} [isCancelled] Is canceled
   * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
   * @param {boolean} [isHotel]
   * @param {boolean} [isSpa]
   * @param {boolean} [isActivity]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  getReservationsRecent(
    offset?: number,
    limit?: number,
    checkInDateFrom?: string,
    checkInDateTo?: string,
    checkOutDateFrom?: string,
    checkOutDateTo?: string,
    isCancelled?: boolean,
    order?:
      | 'created_at'
      | '-created_at'
      | 'check_in_date'
      | '-check_in_date'
      | 'check_out_date'
      | '-check_out_date',
    isHotel?: boolean,
    isSpa?: boolean,
    isActivity?: boolean,
    options?: AxiosRequestConfig
  ): AxiosPromise<ReservationsResponse>

  /**
   * Issue a receipt for the booking owner after payment is recorded
   * @param {number} id
   * @param {IssueReceiptRequest} issueReceiptRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApiInterface
   */
  issueReservationReceipt(
    id: number,
    issueReceiptRequest: IssueReceiptRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<IssueReceiptResponse>
}

/**
 * ReservationApi - object-oriented interface
 * @export
 * @class ReservationApi
 * @extends {BaseAPI}
 */
export class ReservationApi extends BaseAPI implements ReservationApiInterface {
  /**
   * Get cancellation price by id
   * @param {number} id Reservation ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public cancelConfirmation(id: number, options?: AxiosRequestConfig) {
    return ReservationApiFp(this.configuration)
      .cancelConfirmation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Cancel reservation by given id
   * @param {number} id Reservation id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public cancelReservation(id: number, options?: AxiosRequestConfig) {
    return ReservationApiFp(this.configuration)
      .cancelReservation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Create reservation
   * @param {CreateReservationRequest} [createReservationRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public createReservation(
    createReservationRequest?: CreateReservationRequest,
    options?: AxiosRequestConfig
  ) {
    return ReservationApiFp(this.configuration)
      .createReservation(createReservationRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get reservation by id
   * @param {number} id Reservation id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public getReservation(id: number, options?: AxiosRequestConfig) {
    return ReservationApiFp(this.configuration)
      .getReservation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get reservation price
   * @param {number} id Reservation id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public getReservationPrice(id: number, options?: AxiosRequestConfig) {
    return ReservationApiFp(this.configuration)
      .getReservationPrice(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Issue a signed PDF URL valid for 12 hours, consuming one receipt view (default limit of five). Returns 403 when the receipt view limit is exhausted.
   * @param {number} id
   * @param {number} receiptId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public getReservationReceipt(
    id: number,
    receiptId: number,
    options?: AxiosRequestConfig
  ) {
    return ReservationApiFp(this.configuration)
      .getReservationReceipt(id, receiptId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get reservation list
   * @param {number} [offset] Offset  * Default: 0
   * @param {number} [limit] Limit  * Default: 50  * Max: 1000
   * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
   * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {boolean} [isCancelled] Is canceled
   * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
   * @param {boolean} [isHotel]
   * @param {boolean} [isSpa]
   * @param {boolean} [isActivity]
   * @param {number} [transaction]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public getReservations(
    offset?: number,
    limit?: number,
    checkInDateFrom?: string,
    checkInDateTo?: string,
    checkOutDateFrom?: string,
    checkOutDateTo?: string,
    isCancelled?: boolean,
    order?:
      | 'created_at'
      | '-created_at'
      | 'check_in_date'
      | '-check_in_date'
      | 'check_out_date'
      | '-check_out_date',
    isHotel?: boolean,
    isSpa?: boolean,
    isActivity?: boolean,
    transaction?: number,
    options?: AxiosRequestConfig
  ) {
    return ReservationApiFp(this.configuration)
      .getReservations(
        offset,
        limit,
        checkInDateFrom,
        checkInDateTo,
        checkOutDateFrom,
        checkOutDateTo,
        isCancelled,
        order,
        isHotel,
        isSpa,
        isActivity,
        transaction,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get recent reservation list
   * @param {number} [offset] Offset  * Default: 0
   * @param {number} [limit] Limit  * Default: 50  * Max: 1000
   * @param {string} [checkInDateFrom] Check-in date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkInDateTo] Check-in date（&#x60;yyyy-MM-dd&#x60;）
   * @param {string} [checkOutDateFrom] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {string} [checkOutDateTo] Check-out date(&#x60;yyyy-MM-dd&#x60;)
   * @param {boolean} [isCancelled] Is canceled
   * @param {'created_at' | '-created_at' | 'check_in_date' | '-check_in_date' | 'check_out_date' | '-check_out_date'} [order] Order   * Default: &#x60;-created_at&#x60;(desc)
   * @param {boolean} [isHotel]
   * @param {boolean} [isSpa]
   * @param {boolean} [isActivity]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public getReservationsRecent(
    offset?: number,
    limit?: number,
    checkInDateFrom?: string,
    checkInDateTo?: string,
    checkOutDateFrom?: string,
    checkOutDateTo?: string,
    isCancelled?: boolean,
    order?:
      | 'created_at'
      | '-created_at'
      | 'check_in_date'
      | '-check_in_date'
      | 'check_out_date'
      | '-check_out_date',
    isHotel?: boolean,
    isSpa?: boolean,
    isActivity?: boolean,
    options?: AxiosRequestConfig
  ) {
    return ReservationApiFp(this.configuration)
      .getReservationsRecent(
        offset,
        limit,
        checkInDateFrom,
        checkInDateTo,
        checkOutDateFrom,
        checkOutDateTo,
        isCancelled,
        order,
        isHotel,
        isSpa,
        isActivity,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Issue a receipt for the booking owner after payment is recorded
   * @param {number} id
   * @param {IssueReceiptRequest} issueReceiptRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReservationApi
   */
  public issueReservationReceipt(
    id: number,
    issueReceiptRequest: IssueReceiptRequest,
    options?: AxiosRequestConfig
  ) {
    return ReservationApiFp(this.configuration)
      .issueReservationReceipt(id, issueReceiptRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Create transaction
     * @param {CreateTransactionRequest} [createTransactionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTransaction: async (
      createTransactionRequest?: CreateTransactionRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/transactions`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createTransactionRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get verification configuration before a new GMO authorization
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentBotVerification: async (
      id: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getPaymentBotVerification', 'id', id)
      const localVarPath = `/transactions/{id}/bot-verification`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Get transaction data
     * @param {number} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransaction: async (
      transactionId: number,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('getTransaction', 'transactionId', transactionId)
      const localVarPath = `/transactions/{transaction_id}`.replace(
        `{${'transaction_id'}}`,
        encodeURIComponent(String(transactionId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Apply coupon code
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {number} transactionId Transaction ID
     * @param {PatchDiscountRequest} [patchDiscountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDiscount: async (
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      transactionId: number,
      patchDiscountRequest?: PatchDiscountRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'propertySlug' is not null or undefined
      assertParamExists('patchDiscount', 'propertySlug', propertySlug)
      // verify required parameter 'roomSlug' is not null or undefined
      assertParamExists('patchDiscount', 'roomSlug', roomSlug)
      // verify required parameter 'planSlug' is not null or undefined
      assertParamExists('patchDiscount', 'planSlug', planSlug)
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists('patchDiscount', 'transactionId', transactionId)
      const localVarPath =
        `/hotels/{property_slug}/rooms/{room_slug}/plans/{plan_slug}/price/discount`
          .replace(
            `{${'property_slug'}}`,
            encodeURIComponent(String(propertySlug))
          )
          .replace(`{${'room_slug'}}`, encodeURIComponent(String(roomSlug)))
          .replace(`{${'plan_slug'}}`, encodeURIComponent(String(planSlug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      if (transactionId !== undefined) {
        localVarQueryParameter['transaction_id'] = transactionId
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        patchDiscountRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Update transaction
     * @param {number} transactionId
     * @param {UpdateTransactionInputRequest} [updateTransactionInputRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionInput: async (
      transactionId: number,
      updateTransactionInputRequest?: UpdateTransactionInputRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists(
        'updateTransactionInput',
        'transactionId',
        transactionId
      )
      const localVarPath = `/transactions/{transaction_id}/input`.replace(
        `{${'transaction_id'}}`,
        encodeURIComponent(String(transactionId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication FidAuthToken required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      )

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateTransactionInputRequest,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TransactionApiAxiosParamCreator(configuration)
  return {
    /**
     * Create transaction
     * @param {CreateTransactionRequest} [createTransactionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createTransaction(
      createTransactionRequest?: CreateTransactionRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CreateTransaction201Response>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createTransaction(
          createTransactionRequest,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     *
     * @summary Get verification configuration before a new GMO authorization
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPaymentBotVerification(
      id: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<BotVerificationConfigurationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPaymentBotVerification(id, options)
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Get transaction data
     * @param {number} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTransaction(
      transactionId: number,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<TransactionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTransaction(
        transactionId,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Apply coupon code
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {number} transactionId Transaction ID
     * @param {PatchDiscountRequest} [patchDiscountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async patchDiscount(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      transactionId: number,
      patchDiscountRequest?: PatchDiscountRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.patchDiscount(
        propertySlug,
        roomSlug,
        planSlug,
        transactionId,
        patchDiscountRequest,
        options
      )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
    /**
     * Update transaction
     * @param {number} transactionId
     * @param {UpdateTransactionInputRequest} [updateTransactionInputRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTransactionInput(
      transactionId: number,
      updateTransactionInputRequest?: UpdateTransactionInputRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateTransactionInput(
          transactionId,
          updateTransactionInputRequest,
          options
        )
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      )
    },
  }
}

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionApiFp(configuration)
  return {
    /**
     * Create transaction
     * @param {CreateTransactionRequest} [createTransactionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTransaction(
      createTransactionRequest?: CreateTransactionRequest,
      options?: any
    ): AxiosPromise<CreateTransaction201Response> {
      return localVarFp
        .createTransaction(createTransactionRequest, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Get verification configuration before a new GMO authorization
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPaymentBotVerification(
      id: number,
      options?: any
    ): AxiosPromise<BotVerificationConfigurationResponse> {
      return localVarFp
        .getPaymentBotVerification(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Get transaction data
     * @param {number} transactionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTransaction(
      transactionId: number,
      options?: any
    ): AxiosPromise<TransactionResponse> {
      return localVarFp
        .getTransaction(transactionId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Apply coupon code
     * @param {string} propertySlug Property slug
     * @param {string} roomSlug Room category slug
     * @param {string} planSlug Plan slug
     * @param {number} transactionId Transaction ID
     * @param {PatchDiscountRequest} [patchDiscountRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    patchDiscount(
      propertySlug: string,
      roomSlug: string,
      planSlug: string,
      transactionId: number,
      patchDiscountRequest?: PatchDiscountRequest,
      options?: any
    ): AxiosPromise<object> {
      return localVarFp
        .patchDiscount(
          propertySlug,
          roomSlug,
          planSlug,
          transactionId,
          patchDiscountRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Update transaction
     * @param {number} transactionId
     * @param {UpdateTransactionInputRequest} [updateTransactionInputRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransactionInput(
      transactionId: number,
      updateTransactionInputRequest?: UpdateTransactionInputRequest,
      options?: any
    ): AxiosPromise<object> {
      return localVarFp
        .updateTransactionInput(
          transactionId,
          updateTransactionInputRequest,
          options
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * TransactionApi - interface
 * @export
 * @interface TransactionApi
 */
export interface TransactionApiInterface {
  /**
   * Create transaction
   * @param {CreateTransactionRequest} [createTransactionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApiInterface
   */
  createTransaction(
    createTransactionRequest?: CreateTransactionRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<CreateTransaction201Response>

  /**
   *
   * @summary Get verification configuration before a new GMO authorization
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApiInterface
   */
  getPaymentBotVerification(
    id: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<BotVerificationConfigurationResponse>

  /**
   * Get transaction data
   * @param {number} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApiInterface
   */
  getTransaction(
    transactionId: number,
    options?: AxiosRequestConfig
  ): AxiosPromise<TransactionResponse>

  /**
   * Apply coupon code
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {number} transactionId Transaction ID
   * @param {PatchDiscountRequest} [patchDiscountRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApiInterface
   */
  patchDiscount(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    transactionId: number,
    patchDiscountRequest?: PatchDiscountRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<object>

  /**
   * Update transaction
   * @param {number} transactionId
   * @param {UpdateTransactionInputRequest} [updateTransactionInputRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApiInterface
   */
  updateTransactionInput(
    transactionId: number,
    updateTransactionInputRequest?: UpdateTransactionInputRequest,
    options?: AxiosRequestConfig
  ): AxiosPromise<object>
}

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI implements TransactionApiInterface {
  /**
   * Create transaction
   * @param {CreateTransactionRequest} [createTransactionRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public createTransaction(
    createTransactionRequest?: CreateTransactionRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .createTransaction(createTransactionRequest, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get verification configuration before a new GMO authorization
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public getPaymentBotVerification(id: number, options?: AxiosRequestConfig) {
    return TransactionApiFp(this.configuration)
      .getPaymentBotVerification(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Get transaction data
   * @param {number} transactionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public getTransaction(transactionId: number, options?: AxiosRequestConfig) {
    return TransactionApiFp(this.configuration)
      .getTransaction(transactionId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Apply coupon code
   * @param {string} propertySlug Property slug
   * @param {string} roomSlug Room category slug
   * @param {string} planSlug Plan slug
   * @param {number} transactionId Transaction ID
   * @param {PatchDiscountRequest} [patchDiscountRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public patchDiscount(
    propertySlug: string,
    roomSlug: string,
    planSlug: string,
    transactionId: number,
    patchDiscountRequest?: PatchDiscountRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .patchDiscount(
        propertySlug,
        roomSlug,
        planSlug,
        transactionId,
        patchDiscountRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Update transaction
   * @param {number} transactionId
   * @param {UpdateTransactionInputRequest} [updateTransactionInputRequest]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  public updateTransactionInput(
    transactionId: number,
    updateTransactionInputRequest?: UpdateTransactionInputRequest,
    options?: AxiosRequestConfig
  ) {
    return TransactionApiFp(this.configuration)
      .updateTransactionInput(
        transactionId,
        updateTransactionInputRequest,
        options
      )
      .then((request) => request(this.axios, this.basePath))
  }
}
